<template>
	<div class="new-order-page" v-if="this.order_available">
		 <!-- <h3>
      <p v-html="$t('bankingHoursMesage') "></p>
    </h3> -->
		<h1>{{ $t("newOrderTitle") }}</h1>
		<!-- 
		<div class="order-selection-bar">
			<img
				:src="
					require('@/assets/images/choose-action-bar-' +
						this.orderStep +
						'.png')
				"
			/>
    <div>-->
		<div class="prog-bar">
			<ul class="step-pog-bar">
				<li v-for="step in 5" :key="step" :class="orderStep >= step && 'active'">
					{{ $t("orderStep_" + step) }}
				</li>
			</ul>
		</div>
		<br />
		<h1 align="center">{{ $t("orderStep_" + this.orderStep + "_title") }}</h1>

		<div v-if="this.orderStep > 1 && this.orderStep < 5">
			<h3 class="return">
				<a href="#" @click="backOneStep()">
					<font-awesome-icon icon="chevron-left" />
					<span>{{ $t("backButtonLabel") }}</span>
				</a>
			</h3>
		</div>

		<!-- order step 1, type of order -->
		<table v-if="this.orderStep === 1" cellpadding="0" cellspacing="20" width="90%" align="center"
			class="choose mobile-table">
			<tr>
				<td valign="middle">
					<a href="#" class="p-voucher" @click="selectOrderType('PAPER')">
						{{ $t("orderTypePaper") }}
					</a>
				</td>
				<td valign="middle">
					<a href="#" class="top-up-cards" @click="selectOrderType('NEWCR')">
						{{ $t("orderTypeCard") }}
					</a>
				</td>
			</tr>
			<tr>
				<td valign="middle">
					<a href="#" class="duplicate-order" @click="selectOrderType('DUPLICATE')">{{
						$t("orderTypeDuplicate")
					}}</a>
				</td>
				<td width="50%">
					<!-- <a href="#" class="plastic-cards" @click="selectOrderType('NEWCR')">  -->
					<!-- {{
            $t("orderTypeCard")
          }}-->
					<!-- </a> -->
				</td>
			</tr>
		</table>

		<!-- order step 2, product brand -->
		<div v-if="this.orderStep === 2">
			<div class="products" v-if="this.orderType !== 'DUPLICATE'">
				<div class="container-alb moverflow">
					<div class="table-header-wrapper" v-if="orderType !== 'PAPER'">
						<div class="left">
							<h3 class="table-title">{{ $t("pshysicalCardsTitle") }}</h3>
						</div>
					</div>
					<b-container class="border-box">
						<b-row class="border-box" align-v="center">
							<b-col class="border-box " lg="3" md="3" sm="6" v-for="(entry, index) in this.orderProducts"
								:key="index" align-v="center">
								<div class="wrapper-product border-box align-items-center">
									<a href="#" @click="selectProduct(entry, false)">
										<div class="table-header-wrapper">
											<div class="left">
												<h3 class="table-title">
													<img style="max-height: 55px" :src="require('@/assets/images/choose-up-' +
														(entry.paper === 0 ? entry.card : entry.paper) + '_' + entry.order +
														'_text.png')
														" />
												</h3>
											</div>
										</div>
										<img v-if="orderType !== 'PAPER'" :src="require('@/assets/images/choose-up-' +
											(entry.paper === 0 ? entry.card : entry.paper) + '_' + entry.order +
											'.png')
											" />
									</a>
								</div>
								<!-- <div class="wrapper-product border-box align-items-center" >
								<a href="#" @click="selectProduct(entry, false)" >
									<img 
										:src="
											require('@/assets/images/choose-up-' +
												(entry.paper === 0 ? entry.card : entry.paper) + '_' + entry.order +
												'.png')
										"
									/>
								</a>
							</div> -->
							</b-col>
						</b-row>
					</b-container>
				</div>

				<div class="container-alb moverflow" v-if="this.orderType === 'NEWCR'">
					<div class="table-header-wrapper">
						<div class="left">
							<h3 class="table-title">{{ $t("digitalCardsTitle") }}</h3>
						</div>
					</div>
					<b-container class="border-box">
						<b-row class="border-box" align-v="center">
							<b-col class="border-box " lg="3" md="3" sm="6" v-for="(entry, index) in this.orderProducts"
								:key="index" align-v="center">
								<div class="wrapper-product border-box align-items-center">
									<a href="#" @click="selectProduct(entry, true)">
										<div class="table-header-wrapper">
											<div class="left">
												<h3 class="table-title">
													<img style="max-height: 55px" :src="require('@/assets/images/choose-up-' +
														(entry.paper === 0 ? entry.card : entry.paper) + '_' + entry.order +
														' virtual_text.png')
														" />
												</h3>

											</div>
										</div>
										<img :src="require('@/assets/images/choose-up-' +
											(entry.paper === 0 ? entry.card : entry.paper) + '_' + entry.order +
											' virtual.png')
											" />
									</a>
								</div>
							</b-col>
						</b-row>
					</b-container>
				</div>
			</div>
			<div class="container-alb" v-if="this.orderType === 'DUPLICATE'">
				<div v-if="customer.products.length > 0">
					<div class="table-header-wrapper">
						<div class="left">
							<strong>{{ $t("invoicesFilterProduct") }} :</strong>
							<select class="filtrare" style="width: auto" @change="selectProductDuplicate">
								<option v-for="(entry, index) in this.orderProducts" :key="index" :value="index" :selected="(entry.card === newOrder.product.card &&
									entry.card !== 0) ||
									(entry.paper === newOrder.product.paper &&
										entry.paper !== 0)
									">
									{{ entry.name }}
								</option>
							</select>
						</div>
						<div class="right"></div>
					</div>

					<orders-table-desktop @change="sortOrdersBy" @click="selectOrder" :companyOrders="previousOrders"
						:pending="false" :duplicate="true" :company="this.customer" />
				</div>
			</div>
		</div>

		<!-- order step 3, configure order -->
		<div v-if="this.orderStep === 3">
			<!-- v-if="this.newOrder.type !== 'DUPLICATE'" -->
			<div>
				<div v-if="this.newOrder.type === 'PAPER'">
					<a class="nonpersonalised-vouchers" :class="newOrder.grouping === 1 && 'active'"
						@click="selectGrouping(1)">{{ $t("orderPersonalizedGroupingCarnet") }}</a>
					<a class="personalised-vouchers" :class="newOrder.grouping === 2 && 'active'"
						@click="selectGrouping(2)">{{ $t("orderPersonalizedGroupingPachet") }}</a>

					<br clear="all" />
				</div>
				<br />
				<p v-if="this.newOrder.type === 'PAPER'">
					<strong>{{ $t("orderPersonalizeVouchersTitle") }}</strong>
				</p>
				<div class="container-alb" v-if="this.newOrder.type === 'PAPER'">
					<table cellpadding="20" cellspacing="0" width="95%" class="hover-table mobile-table" align="center">
						<tr v-if="productLogo">
							<td>
								<strong>{{ $t("orderPersonalizedIconLabel") }}</strong>
								&nbsp;&nbsp;&nbsp;&nbsp;
							</td>
							<td>
								<!-- <input type="checkbox" class="checkbox-custom" v-model="newOrder.logo" /> -->
								<!-- <span>{{$t('orderPersonalizedPrintIconLabel')}}&nbsp;&nbsp;</span> -->
								<a align="right" class="status-background background-will-expire"
									@click="showModalPopup('modal_popup_openLogo', true)">&nbsp;&nbsp;{{
										$t("orderPersonalizedViewIconLabel")
									}}&nbsp;&nbsp;</a>
							</td>
						</tr>
						<tr>
							<td valign="top">
								<span class="msg-label">
									<strong>{{ $t("orderPersonalizedMessageLabel") }}</strong>
								</span>
							</td>
							<td align="left" width="75%" valign="top">
								<input type="text" v-model="newOrder.text1" maxlength="27" class="input-msg" />
								<input type="text" v-model="newOrder.text2" maxlength="27" class="input-msg" />
							</td>
						</tr>
					</table>
				</div>
				<br />
				<div v-if="this.newOrder.personalized">
					<p>
						<strong>{{ $t("orderAddBeneficiariesTitle") }}</strong>
					</p>

					<div class="container-alb padding-top-0">
						<div class="navigationSlider order-type">
							<a @click="order_type = true" class="cardusersTab" :class="order_type && 'active'">{{
								$t("manualOrderTabTitle")
							}}</a>
							<a v-if="!isOrderProductReward || (isOrderProductReward && this.newOrder.virtual) || this.userRole === 'FAC'"
								@click="order_type = false" class="companiesTab" :class="!order_type && 'active'">{{
									$t("excelOrderTabTitle") }}</a>
						</div>

						<table v-if="order_type === false" cellpadding="20" cellspacing="0" width="95%"
							class="hover-table mobile-table" align="center">
							<tr>
								<td colspan="2">
									<strong>{{ $t("orderUploadFileTitle") }}</strong>
								</td>
							</tr>

							<tr>
								<td valign="top">
									<strong>{{ $t("orderFileModelLabel") }}</strong>
								</td>

								<td align="left" width="75%" valign="top">
									<a class="status-background background-active" style="margin-right: 5px"
										@click="downloadModel">
										{{ $t("downloadLinkText") }}
									</a>
									<strong>{{ $t("orderFileModelText") }}</strong>
								</td>
							</tr>
							<tr>
								<td valign="top" v-if="!isOrderProductReward">
									<strong>{{ $t("deliveryPointLabel") }}</strong>
								</td>
								<td v-if="!isOrderProductReward">
									<select class="input-add-beneficiary filtrare" v-model="b_deliveryAddressExcel">
										<option value="0">{{ $t('chooseAllAddressOption') }}</option>
										<option v-for="(delivery, index) in deliveryAddresses" :key="index"
											:value="delivery.codcom">
											{{
												getAddressName(delivery)
											}}
										</option>
									</select>
								</td>
							</tr>
							<tr>
								<td valign="top">
									<strong>{{ $t("orderFileUploadLabel") }}</strong>
								</td>
								<td>
									{{ $t("orderFileUploadText") }}
									<br />
									<br />

									<!-- <input type="file" ref="file" @change="uploadFile()" /> -->
									<b-form-file v-model="fileReceived" ref="file"
										:placeholder="$t('orderFileUploadPlaceholder')"
										:browse-text="$t('orderFileUploadButton')" accept=".xls, .xlsx"
										@input="uploadFile"></b-form-file>
								</td>
							</tr>

						</table>

						<table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center"
							v-if="this.newOrder.type !== 'PAPER' && order_type">

							<tr>
								<td v-if="!isOrderProductReward">
									<strong>{{ $t("deliveryPointLabel") }}</strong>
								</td>
								<td v-if="!isOrderProductReward">

									<select class="input-add-beneficiary filtrare" v-model="b_deliveryAddressExcel"
										@change="loadCustomerBeneficiaries()">
										<option value="0">{{ $t('chooseAllAddressOption') }}</option>
										<option v-for="(delivery, index) in deliveryAddresses" :key="index"
											:value="delivery.codcom">
											{{
												getAddressName(delivery)
											}}
										</option>
									</select>
								</td>
							</tr>
							<tr v-if="!isOrderProductReward">
								<td colspan="2">
									<span class="margin-right-5">
										<strong>{{ $t("defaultAmountValue") }}</strong>
									</span>
								</td>
								<td>
									<span class="currencyinput">
										<span v-html="$t('currency')"></span>
										&nbsp;
										<input type="text" v-model="defaultTicketValue" class="input-add-beneficiary amount"
											v-on:blur="
												defaultTicketValue = convertValueToDecimalVariable(
													defaultTicketValue
												)
												" />
									</span>
								</td>
							</tr>
							<tr v-if="!isOrderProductReward">
								<td colspan="2">
									<strong>{{ $t("deliveryPointNoBeneficiaries") }}</strong>
									&nbsp; &nbsp;
								</td>
								<td class="input-add-beneficiary">
									<img src="@/assets/images/user-gri.svg" width="20" />&nbsp;
									<strong v-if="this.customerBeneficiaries">{{
										this.totalNumberOfBeneficiaries
									}}</strong>
									<strong v-else>0</strong>
								</td>
							</tr>
							<tr v-if="isOrderProductReward">
								<td colspan="2">
									<strong>{{ $t("displayTextLabel") }}</strong>
									&nbsp; &nbsp;
								</td>
								<td class="input-add-beneficiary">
									<strong>{{
										b_display_text
									}}</strong>
								</td>
							</tr>
							<tr>
								<td colspan="2">
									<strong>{{ isOrderProductReward ? $t("nominalValueRewards") : $t("nominalValue")
									}}</strong> &nbsp; &nbsp;
								</td>
								<td class="input-add-beneficiary">
									<strong v-if="this.customerBeneficiaries">{{
										this.totalNominalValue | toCurrency
									}}</strong>
									<strong v-else>0 | toCurrency</strong>
								</td>
								<td align="right" colspan="2" v-if="!isOrderProductReward">
									<div style="position: relative">
										<input type="text" v-bind:placeholder="$t('beneficiariesFilterKeyword')"
											class="formedituser search-input" v-model="keyword"
											v-on:keyup.enter="searchCustomerBeneficiaries()" />
										<a class="search-btn cursor-pointer" @click="searchCustomerBeneficiaries()">
											<!-- <img src="@/assets/images/search.svg" alt /> -->
										</a>
									</div>
								</td>
							</tr>
						</table>

						<div class="scroll-add-new-beneficiary"
							v-if="this.newOrder.type !== 'PAPER' && order_type && !isOrderProductReward">
							<table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">

								<tr>
									<td valign="middle">
										<strong>{{ $t("noCrtLabel") }}</strong>
									</td>
									<td valign="middle">
										<strong>{{ $t("beneficiariesTableSurname") }}</strong>&nbsp;
										<img src="@/assets/images/arrow-down-fill.svg" @click="changeReverse('first_name')"
											:style="sortBy === 'first_name' &&
												reverse &&
												'transform: rotate(180deg)'
												" />
									</td>
									<td class="priority-2" valign="middle">
										<strong>{{ $t("beneficiariesTableName") }}</strong>&nbsp;
										<img src="@/assets/images/arrow-down-fill.svg" @click=" changeReverse('last_name')"
											:style="sortBy === 'last_name' &&
												reverse &&
												'transform: rotate(180deg)'
												" />
									</td>
									<td class="priority-3" valign="middle">
										<strong v-html="$t('employeeIdCardLabel')"></strong>&nbsp;
										<img src="@/assets/images/arrow-down-fill.svg"
											@click="changeReverse('from_source_id')" :style="sortBy === 'from_source_id' &&
												reverse &&
												'transform: rotate(180deg)'
												" />
									</td>
									<td class="priority-5" valingn="middle" v-if="!newOrder.virtual">
										<strong>{{ $t("deliveryPointLabel") }}</strong>
									</td>
									<td v-if="newOrder.virtual" class="priority-5" valign="middle">
										<strong>{{ $t("beneficiariesTableMobile") }}</strong>
									</td>
									<td v-if="newOrder.virtual" class="priority-5" valign="middle">
										<strong>{{ $t("beneficiariesTableEmail") }}</strong>
									</td>
									<td class="priority-5" valign="middle">
										<strong>{{ $t("beneficiariesTableTicketValue") }}</strong>&nbsp;
									</td>
									<td valingn="middle">
										<strong>{{ $t("newOrderActionSelect") }}</strong>
									</td>
								</tr>
								<tr class="background-will-expire" style="color: #fff" v-if="this.newOrder.grouping !== 2">
									<td colspan="100">
										<strong>{{
											isOrderProductReward ? $t("addBeneficiariesTitleRewards") :
											$t("addBeneficiariesTitle") }}</strong>
									</td>
								</tr>
								<tr class="trhover parent background-will-expire">
									<td valign="middle">
										<a @click="openAddBeneficiaryMobile()"
											class="detailsOrderMobile priority-show-7 display-inline-block">
											<p v-if="openAddBeneficiary">{{
												$t("seeLessLabel")
											}}</p>

											<p v-else>{{
												$t("seeMoreLabel")
											}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>

											<!-- <font-awesome-icon
												icon="minus-circle"
												v-if="openAddBeneficiary"
											/>
											
											<font-awesome-icon
												icon="plus-circle"
												v-else
											/>&nbsp;&nbsp; -->
										</a>
									</td>
									<td valign="middle">
										<input type="text" v-model="b_first_name" class="input-add-beneficiary employee" />
									</td>
									<td class="priority-2" valign="middle">
										<input type="text" v-model="b_last_name" class="input-add-beneficiary" />
									</td>
									<td class="priority-3" valign="middle">
										<input type="text" v-model="b_cnp" class="input-add-beneficiary nocase" />
									</td>
									<td class="priority-5" valign="middle" v-if="!newOrder.virtual">

										<select class="input-add-beneficiary filtrare" v-model="b_deliveryAddresses">
											<option v-for="(delivery, index) in deliveryAddresses" :key="index"
												:value="delivery.codcom">
												{{
													getAddressName(delivery)
												}}
											</option>
										</select>
									</td>
									<td v-if="this.newOrder.virtual" class="priority-5" valign="middle">
										<input type="text" v-model="b_mobileNumber" class="input-add-beneficiary phone"
											@keyup="
												b_mobileNumber = mobilePhoneOnlyNumbers(b_mobileNumber)
												" />
									</td>
									<td v-if="this.newOrder.virtual" class="priority-5" valign="middle">
										<input type="text" v-model="b_email" required autocomplete="off"
											class="input-add-beneficiary nocase email" />
									</td>
									<td class="priority-5" valign="middle">
										<span class="currencyinput">
											<span v-html="$t('currency')"></span>
											&nbsp;
											<input type="text" v-model="b_nominal_value" v-on:blur="
												b_nominal_value = convertValueToDecimalVariable(
													b_nominal_value
												)
												" class="input-add-beneficiary amount" />
										</span>
									</td>
									<td>
										<a @click="addBeneficiary()" class="custom-font-awesome">
											<font-awesome-icon icon="plus-circle" />
										</a>
									</td>
									<td class="priority-7" valign="middle">
										<input type="text" v-model="b_address1" class="input-add-beneficiary"
											v-if="!newOrder.virtual" />
									</td>
									<td class="priority-7" valign="middle">
										<input type="text" v-model="b_address2" class="input-add-beneficiary"
											v-if="!newOrder.virtual" />
									</td>
									<td class="priority-7" valign="middle">
										<input type="text" v-model="b_addressCity" class="input-add-beneficiary"
											v-if="!newOrder.virtual" />
									</td>
									<td class="priority-7" valign="middle" v-if="!newOrder.virtual">
										<input type="text" v-model="b_addressPostalCode" class="input-add-beneficiary" />
									</td>
								</tr>
								<tr class="background-will-expire" v-if="this.newOrder.virtual && orderType">
									<td colspan="100">
										<strong>{{ $t("digitalCardsMobileInfo") }}</strong>
									</td>
								</tr>
								<tr v-if="this.customerBeneficiaries === null && this.orderType !== 'PAPER'">
									<td colspan="5">
										<div class="loading">
											<img src="@/assets/images/loading.gif" />
										</div>
									</td>
								</tr>

								<tr v-if="this.customerBeneficiaries && this.customerBeneficiaries.size === 0">
									<td colspan="5">{{ $t("noBeneficiariesInfoMessage") }}</td>
								</tr>
								<tr v-show="openAddBeneficiary" class="child  background-will-expire  white-font trhover">
									<td colspan="100">
										<p class="priority-show-2">
											<strong>{{ $t("beneficiariesTableSurname") }} :
												&nbsp;&nbsp;</strong>
											<input type="text" v-model="b_first_name" class="input-add-beneficiary" />
										</p>
										<p class="priority-show-3">
											<strong>{{ $t("beneficiariesTableName") }} :
												&nbsp;&nbsp;</strong>
											<input type="text" v-model="b_last_name" class="input-add-beneficiary" />
										</p>
										<p class="priority-show-5" v-if="!newOrder.virtual">
											<strong>{{ $t("deliveryPointLabel") }} :</strong>&nbsp;
											<span>
												<select class="input-add-beneficiary filtrare"
													v-model="b_deliveryAddresses">
													<option v-for="(delivery, index) in deliveryAddresses" :key="index"
														:value="delivery.codcom">
														{{
															getAddressName(delivery)
														}}
													</option>
												</select>
											</span>
										</p>
										<p v-if="newOrder.virtual" class="priority-show-5">
											<strong>{{ $t("beneficiariesTableMobile") }}:
												&nbsp;&nbsp;</strong>
											<input type="text" v-model="b_mobileNumber"
												class="input-add-beneficiary phone" />
										</p>
										<p v-if="newOrder.virtual" class="priority-show-5">
											<strong>{{ $t("beneficiariesTableEmail") }}: &nbsp;&nbsp;</strong>
											<input type="text" v-model="b_email" required autocomplete="off"
												class="input-add-beneficiary nocase email" />
										</p>
										<p class="priority-show-5">
											<strong>{{ $t("beneficiariesTableTicketValue") }} :</strong>&nbsp;
											<span>
												<span class="currencyinput">
													<span v-html="$t('currency')"></span>
													&nbsp;
													<input type="text" v-model="b_nominal_value"
														class="input-add-beneficiary amount" />
												</span>
											</span>
										</p>
										<p class="priority-show-7 " v-if="!newOrder.virtual">
										<table class="hover-table">
											<tr>
												<td class="table-mobile">
													<strong>{{ $t("beneficiariesTableAddress1") }} :
														&nbsp;&nbsp;</strong>
													<input type="text" v-model="b_address1" class="input-add-beneficiary" />
												</td>
												<td class="table-mobile">
													<span>
														<strong>{{ $t("beneficiariesTableAddress2") }} :
															&nbsp;&nbsp;</strong>
														<input type="text" v-model="b_address2"
															class="input-add-beneficiary" />
													</span>
												</td>
												<td class="table-mobile">
													<strong>{{ $t("beneficiariesTableAddressCity") }} :
														&nbsp;&nbsp;</strong>
													<input type="text" v-model="b_addressCity"
														class="input-add-beneficiary" />
												</td>
											</tr>
										</table>
										</p>
										<p class="table-mobile" v-if="!newOrder.virtual">
											<strong>{{ $t("beneficiariesTableAddressPostalCode") }} :
												&nbsp;&nbsp;</strong>
											<input type="text" v-model="b_addressPostalCode"
												class="input-add-beneficiary" />
										</p>


									</td>
								</tr>
								<template v-for="(entry, index) in this.customerBeneficiaries">
									<tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
										<td valign="middle">
											<a @click="selectBeneficiaryMobile(index)"
												class="detailsOrderMobile  display-inline-block" :class="entry.newBeneficiary
													? 'priority-show-7'
													: 'priority-show-5'
													">
												<font-awesome-icon icon="minus-circle"
													v-if="detailsMobile && entry === selectedBeneficiary" />
												<font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
											</a>
											<span class="crt">&nbsp;&nbsp;{{ index + 1 }}</span>
										</td>
										<td valign="middle">{{ entry.first_name }}</td>
										<td class="priority-2" valign="middle">
											{{ entry.last_name }}
										</td>
										<td class="priority-3" valign="middle">
											{{ entry.from_source_id }}
										</td>

										<td class="priority-5" valign="middle" v-if="!newOrder.virtual">
											<span>{{ getAddressDisplayName(entry.address) }}</span>
										</td>
										<td class="priority-5" valign="middle" v-if="newOrder.virtual">
											{{ entry.phone }}
										</td>

										<td class="priority-5" valign="middle" v-if="newOrder.virtual">
											{{ entry.email }}
										</td>
										<td class="priority-5" valign="middle">
											<span class="currencyinput">
												<span v-html="$t('currency')"></span>
												&nbsp;
												<input type="text" :id="'nominal_value_' + entry.from_source_id"
													v-model="entry.nominal_value" v-on:blur="
														entry.nominal_value = convertValueToDecimalVariable(
															entry.nominal_value
														)
														" class="input-add-beneficiary amount" />
											</span>
										</td>

										<td valign="middle">
											<a v-if="entry.newBeneficiary" @click="deleteBeneficiary(index)"
												class="custom-font-awesome">
												<font-awesome-icon icon="minus-circle" />
											</a>
										</td>
									</tr>
									<tr :key="customerBeneficiaries.length + index" class="child"
										:class="index % 2 === 0 && 'gri-cell'"
										v-show="detailsMobile && entry === selectedBeneficiary">
										<td colspan="12">
											<p class="priority-show-2">
												<strong>{{ $t("beneficiariesTableName") }} :
													&nbsp;&nbsp;</strong>
												<span>{{ entry.last_name }}</span>
											</p>
											<p class="priority-show-3">
												<strong v-html="$t('employeeIdCardLabel')"></strong>&nbsp;&nbsp;
												<span>{{ entry.from_source_id }}</span>
											</p>

											<p class="priority-show-5">
												<strong>{{ $t("deliveryPointLabel") }} : &nbsp;&nbsp;</strong>
												<span>{{ getAddressDisplayName(entry.address) }}</span>
											</p>
											<p v-if="newOrder.virtual" class="priority-show-5">
												<strong>{{ $t("beneficiariesTableMobile") }}:
													&nbsp;&nbsp;</strong>
												<span>{{ entry.phone }}</span>
											</p>
											<p v-if="newOrder.virtual" class="priority-show-5">
												<strong>{{ $t("beneficiariesTableEmail") }}:
													&nbsp;&nbsp;</strong>
												<span>{{ entry.email }}</span>
											</p>
											<p class="priority-show-5">
												<strong>{{ $t("beneficiariesTableTotalValue") }} :
													&nbsp;&nbsp;</strong>
												<span class="currencyinput">
													<span v-html="$t('currency')"></span>
													&nbsp;
													<input type="text" v-model="entry.nominal_value"
														class="input-add-beneficiary amount" />
												</span>
											</p>
											<div v-if="entry.beneficiary_address && !newOrder.virtual">
												<p class="priority-show-7 ">
												<table class="hover-table">
													<tr>
														<td class="table-mobile">
															<strong>{{ $t("beneficiariesTableAddress1") }} :
																&nbsp;&nbsp;</strong>
															<input type="text"
																v-model="entry.beneficiary_address.street_name"
																class="input-add-beneficiary" />
														</td>
														<td class="table-mobile">
															<strong>{{ $t("beneficiariesTableAddress2") }} :
																&nbsp;&nbsp;</strong>
															<input type="text"
																v-model="entry.beneficiary_address.street_detail"
																class="input-add-beneficiary" />
														</td>
														<td class="table-mobile">
															<strong>{{ $t("beneficiariesTableAddressCity") }} :
																&nbsp;&nbsp;</strong>
															<input type="text" v-model="entry.beneficiary_address.locality"
																class="input-add-beneficiary" />
														</td>
														<td class="table-mobile">
															<strong>{{ $t("beneficiariesTableAddressPostalCode") }} :
																&nbsp;&nbsp;</strong>
															<input type="text"
																v-model="entry.beneficiary_address.postal_code"
																class="input-add-beneficiary" />
														</td>
													</tr>
												</table>
												</p>
											</div>
										</td>
									</tr>
								</template>
							</table>
						</div>

						<div class="scroll-add-new-beneficiary" v-if="isOrderProductReward && order_type">
							<table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">

								<tr>
									<td valign="middle">
										<strong>{{ $t("noCrtLabel") }}</strong>
									</td>
									<td valign="middle">
										<strong>{{ $t("noOfCardLabelRewards") }}</strong>
									</td>

									<td class="priority-3" valign="middle" v-if="!newOrder.virtual">
										<strong>{{ $t("deliveryPointLabel") }}</strong>
									</td>
									<td v-if="newOrder.virtual" class="priority-3" valign="middle">
										<strong>{{ $t("beneficiariesTableMobile") }}</strong>
									</td>
									<td v-if="newOrder.virtual" class="priority-3" valign="middle">
										<strong>{{ $t("beneficiariesTableEmail") }}</strong>
									</td>


									<td class="priority-3" valingn="middle">
										<strong>{{
											$t("amountVoucherLabel")
										}}</strong>
									</td>
									<td class="priority-4" valign="middle" v-if="!newOrder.virtual">
										<strong>{{ $t("windowText") }}</strong>
									</td>
									<td class="priority-5" valign="middle" v-if="!newOrder.virtual">
										<strong>{{ $t("windowText2") }}</strong>
									</td>
									<td class="priority-6" valign="middle" v-if="!newOrder.virtual">
										<strong>{{ $t("windowText3") }}</strong>
									</td>
									<td class="priority-6" valign="middle" v-if="!newOrder.virtual">
										<strong>{{ $t("windowText4") }}</strong>
									</td>

									<td valingn="middle">
										<strong>{{ $t("newOrderActionSelect") }}</strong>
									</td>
								</tr>
								<tr class="background-will-expire" style="color: #fff" v-if="this.newOrder.grouping !== 2">
									<td colspan="100">
										<strong>{{
											isOrderProductReward ? $t("addBeneficiariesTitleRewards") :
											$t("addBeneficiariesTitle") }}</strong>
									</td>
								</tr>
								<tr class="background-will-expire" v-if="this.newOrder.virtual && orderType">
									<td colspan="100">
										<strong>{{ $t("digitalCardsMobileInfo") }}</strong>
									</td>
								</tr>
								<tr class="trhover parent background-will-expire">
									<td valign="middle">
										<a @click="openAddBeneficiaryMobile()"
											class="detailsOrderMobile display-inline-block" :class="'priority-show-6'
												">
											<font-awesome-icon icon="minus-circle" v-if="openAddBeneficiary" />
											<font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
										</a>
										<!-- <strong>{{index}}</strong> -->
									</td>
									<td valign="middle">
										<span class="currencyinput">
											<input type="text" v-model="bt_booklets"
												class="input-add-beneficiary booklet" />
										</span>
									</td>

									<td :class="newOrder.grouping === 1 ? 'priority-2' : ''" valign="middle"
										v-if="!newOrder.virtual">
										<select class="input-add-beneficiary filtrare" v-model="b_deliveryAddresses">
											<option v-for="(delivery, index) in deliveryAddresses" :key="index"
												:value="delivery.codcom">
												{{
													getAddressName(delivery)
												}}
											</option>
										</select>
									</td>
									<td v-if="this.newOrder.virtual" class="priority-2" valign="middle">
										<input type="text" v-model="b_mobileNumber" class="input-add-beneficiary phone"
											@keyup="
												b_mobileNumber = mobilePhoneOnlyNumbers(b_mobileNumber)
												" />
									</td>
									<td v-if="this.newOrder.virtual" class="priority-2" valign="middle">
										<input type="text" v-model="b_email" autocomplete="off" required
											class="input-add-beneficiary nocase email" />
									</td>
									<td class="priority-3" valign="middle">
										<span class="currencyinput">
											<span v-html="$t('currency')"></span>
											&nbsp;
											<input type="text" v-model="b_nominal_value" v-on:blur="
												b_nominal_value = convertValueToDecimalVariable(b_nominal_value)
												" class="input-add-beneficiary amount" />
										</span>
									</td>

									<td class="priority-4" valign="middle" v-if="!newOrder.virtual">
										<input type="text" v-model="b_address1" disabled class="input-add-beneficiary " />
									</td>
									<td class="priority-5" valign="middle" v-if="!newOrder.virtual">
										<input type="text" v-model="b_address2" class="input-add-beneficiary " />
									</td>
									<td class="priority-6" valign="middle" v-if="!newOrder.virtual">
										<input type="text" v-model="b_addressCity" class="input-add-beneficiary "
											v-if="!newOrder.virtual" />
									</td>
									<td class="priority-6" valign="middle" v-if="!newOrder.virtual">
										<input type="text" v-model="b_addressPostalCode" class="input-add-beneficiary " />
									</td>

									<td>
										<a @click="addBeneficiary()" class="custom-font-awesome">
											<font-awesome-icon icon="plus-circle" />
										</a>
									</td>
								</tr>
								<tr v-show="openAddBeneficiary">
									<td colspan="100">
										<p class="priority-show-2" v-if="!newOrder.virtual">
											<strong>{{ $t("deliveryPointLabel") }}: &nbsp;&nbsp;</strong>
											<select class="input-add-beneficiary filtrare" v-model="b_deliveryAddresses">
												<option v-for="(delivery, index) in deliveryAddresses" :key="index"
													:value="delivery.codcom">
													{{
														getAddressName(delivery)
													}}
												</option>
											</select>
										</p>
										<p v-if="newOrder.virtual" class="priority-show-2">
											<strong>{{ $t("beneficiariesTableMobile") }}:
												&nbsp;&nbsp;</strong>
											<input type="text" v-model="b_mobileNumber"
												class="input-add-beneficiary phone" />
										</p>
										<p v-if="newOrder.virtual" class="priority-show-2">
											<strong>{{ $t("beneficiariesTableEmail") }}: &nbsp;&nbsp;</strong>
											<input type="text" required v-model="b_email" autocomplete="off"
												class="input-add-beneficiary nocase email" />
										</p>
										<p class="priority-show-3">
											<strong>{{
												$t("amountVoucherLabel")
											}}</strong>&nbsp;
											<span class="currencyinput">
												<span v-html="$t('currency')"></span>
												&nbsp;
												<input type="text" v-model="b_nominal_value" v-on:blur="
													b_nominal_value = convertValueToDecimalVariable(
														b_nominal_value
													)
													" class="input-add-beneficiary amount" />
											</span>
										</p>
										<p class="priority-show-4" v-if="!newOrder.virtual">
											<strong>{{ $t("windowText") }}: &nbsp;&nbsp;</strong>
											&nbsp;
											<span>
												<input type="text" v-model="b_address1" disabled
													class="input-add-beneficiary" />
											</span>
										</p>
										<p class="priority-show-5" v-if="!newOrder.virtual">
											<strong>{{ $t("windowText2") }}: &nbsp;&nbsp;</strong>
											&nbsp;
											<span>
												<input type="text" v-model="b_address2" class="input-add-beneficiary" />
											</span>
										</p>
										<p class="priority-show-6" v-if="!newOrder.virtual">
											<strong>{{ $t("windowText3") }}: &nbsp;&nbsp;</strong>
											&nbsp;
											<span>
												<input type="text" v-model="b_addressCity" class="input-add-beneficiary" />
											</span>
										</p>
										<p class="priority-show-6" v-if="!newOrder.virtual">
											<strong>{{ $t("windowText4") }}: &nbsp;&nbsp;</strong>
											&nbsp;
											<span>
												<input type="text" v-model="b_addressPostalCode"
													class="input-add-beneficiary" />
											</span>
										</p>
									</td>
								</tr>
								<template v-for="(entry, index) in this.customerBeneficiaries">
									<tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
										<td valign="middle">
											<a @click="selectBeneficiaryMobile(index)"
												class="detailsOrderMobile display-inline-block" :class="'priority-show-6'
													">
												<font-awesome-icon icon="minus-circle" v-if="(detailsMobile && entry === selectedBeneficiary) ||
													entry.newBeneficiary
													" />
												<font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
											</a>
											<span class="crt">&nbsp;&nbsp;{{ index + 1 }}</span>
										</td>
										<td v-if="newOrder.grouping === 1" valign="middle">
											{{ isOrderProductReward ? entry.cards : entry.booklets }}
										</td>

										<td :class="newOrder.grouping === 1 ? 'priority-2' : ''" valign="middle"
											v-if="!newOrder.virtual">
											<span>{{ getAddressDisplayName(entry.address) }}</span>
										</td>

										<td :class='priority - 2' valign="middle" v-if="newOrder.virtual">
											<span>{{ entry.phone }}</span>
										</td>
										<td :class='priority - 2' valign="middle" v-if="newOrder.virtual">
											<span>{{ entry.email }}</span>
										</td>

										<td class="priority-3" valign="middle">
											<span>
												&nbsp;{{ entry.nominal_value | toCurrency }}
											</span>
										</td>

										<td class="priority-4" valign="middle"
											v-if="isOrderProductReward && !newOrder.virtual">
											{{ entry.beneficiary_address.street_name }}
										</td>
										<td class="priority-5" valign="middle"
											v-if="isOrderProductReward && !newOrder.virtual">
											{{ entry.beneficiary_address.street_detail }}
										</td>
										<td class="priority-6" valign="middle"
											v-if="isOrderProductReward && !newOrder.virtual">
											{{ entry.beneficiary_address.locality }}
										</td>
										<td class="priority-6" valign="middle"
											v-if="isOrderProductReward && !newOrder.virtual">
											{{ entry.beneficiary_address.postal_code }}
										</td>
										<td valign="middle">
											<a v-if="entry.newBeneficiary" @click="deleteBeneficiary(index)"
												class="custom-font-awesome">
												<font-awesome-icon icon="minus-circle" />
											</a>
										</td>
									</tr>
									<tr :key="customerBeneficiaries.length + index" class="child"
										:class="index % 2 === 0 && 'gri-cell'"
										v-show="detailsMobile && entry === selectedBeneficiary">
										<td colspan="100">

											<p v-if="newOrder.grouping === 1 && !newOrder.virtual" class="priority-show-2">
												<strong>{{ $t("deliveryPointLabel") }} : &nbsp;&nbsp;</strong>
												<span>{{ getAddressDisplayName(entry.address) }}</span>
											</p>
											<p class="priority-show-2" v-if="isOrderProductReward && newOrder.virtual">
												<strong>{{ $t("beneficiariesTableMobile") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.phone }}
												</span>
											</p>
											<p class="priority-show-2" v-if="isOrderProductReward && newOrder.virtual">
												<strong>{{ $t("beneficiariesTableEmail") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.email }}
												</span>
											</p>

											<p class="priority-show-3" v-if="isOrderProductReward">
												<strong>{{
													$t("noTicketsValue1Label" + newOrder.grouping)
												}}
													: &nbsp;&nbsp;</strong>
												<span>{{ entry.vouchers }}</span>
											</p>
											<p class="priority-show-3">
												<strong>{{
													isOrderProductReward ? $t("amountVoucherLabel") :
													$t("amountVoucher1Label" + newOrder.grouping) }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.nominal_value | toCurrency }}
												</span>
											</p>
											<p class="priority-show-4" v-if="isOrderProductReward && !newOrder.virtual">
												<strong>{{ $t("windowText") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.beneficiary_address.street_name }}
												</span>
											</p>
											<p class="priority-show-5" v-if="isOrderProductReward && !newOrder.virtual">
												<strong>{{ $t("windowText2") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.beneficiary_address.street_detail }}
												</span>
											</p>
											<p class="priority-show-6" v-if="isOrderProductReward && !newOrder.virtual">
												<strong>{{ $t("windowText3") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.beneficiary_address.locality }}
												</span>
											</p>
											<p class="priority-show-6" v-if="isOrderProductReward && !newOrder.virtual">
												<strong>{{ $t("windowText4") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.beneficiary_address.postal_code }}
												</span>
											</p>
										</td>
									</tr>
								</template>
								<tr v-if="this.customerBeneficiaries === null && this.orderType !== 'PAPER'">
									<td colspan="5">
										<div class="loading">
											<img src="@/assets/images/loading.gif" />
										</div>
									</td>
								</tr>

								<tr v-if="this.customerBeneficiaries && this.customerBeneficiaries.size === 0">
									<td colspan="5">{{ $t("noBeneficiariesInfoMessage") }}</td>
								</tr>
							</table>
						</div>

						<div class="scroll-add-new-beneficiary" v-if="this.newOrder.type === 'PAPER' && order_type">
							<table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
								<tr>
									<td>
										<strong>{{ $t("deliveryPointNoBeneficiaries") }}</strong>
										&nbsp; &nbsp;
									</td>
									<td class="input-add-beneficiary">
										<img src="@/assets/images/user-gri.svg" width="20" />&nbsp;
										<strong v-if="this.customerBeneficiaries">{{
											this.totalNumberOfBeneficiaries
										}}</strong>
										<strong v-else>0</strong>
									</td>
								</tr>
								<tr>
									<td valign="middle">
										<strong>{{ $t("noCrtLabel") }}</strong>
									</td>
									<td v-if="newOrder.grouping === 1" valign="middle">
										<strong>{{ $t("noOfBookletLabel") }}</strong>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-1" valign="middle">
										<strong>{{ $t("beneficiaryVoucherLabel") }}</strong>
									</td>
									<td :class="newOrder.grouping === 1 ? 'priority-2' : ''" valign="middle">
										<strong>{{ $t("deliveryPointLabel") }}</strong>
									</td>
									<td class="priority-2" valingn="middle" v-if="newOrder.grouping === 1">
										<strong>{{
											$t("amountVoucherLabelPaper")
										}}</strong>
									</td>
									<td class="priority-3 numberOfTicket" valign="middle">
										<strong>{{
											$t("noTicketsValue1Label" + newOrder.grouping)
										}}</strong>
									</td>
									<td class="priority-3" valingn="middle">
										<strong>{{
											$t("amountVoucher1Label" + newOrder.grouping)
										}}</strong>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-5 numberOfTicket" valign="middle">
										<strong>{{ $t("noTicketsValue2Label") }}</strong>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-5" valingn="middle">
										<strong>{{ $t("amountVoucher2Label") }}</strong>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-6 numberOfTicket" valign="middle">
										<strong>{{ $t("noTicketsValue3Label") }}</strong>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-6" valign="middle">
										<strong>{{ $t("amountVoucher3Label") }}</strong>
									</td>
									<td valingn="middle">
										<strong>{{ $t("newOrderActionSelect") }}</strong>
									</td>
								</tr>
								<tr class="background-will-expire" style="color: #fff" v-if="this.newOrder.grouping !== 2">
									<td colspan="100">
										<strong>{{
											isOrderProductReward ? $t("addBeneficiariesTitleRewards") :
											$t("addBeneficiariesTitle") }}</strong>
									</td>
								</tr>
								<tr class="background-will-expire" v-if="this.newOrder.virtual && orderType">
									<td colspan="100">
										<strong>{{ $t("digitalCardsMobileInfo") }}</strong>
									</td>
								</tr>
								<tr class="trhover parent background-will-expire">
									<td valign="middle">
										<a @click="openAddBeneficiaryMobile()"
											class="detailsOrderMobile display-inline-block" :class="newOrder.grouping === 1
												? 'priority-show-6'
												: 'priority-show-3'
												">
											<font-awesome-icon icon="minus-circle" v-if="openAddBeneficiary" />
											<font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
										</a>
										<!-- <strong>{{index}}</strong> -->
									</td>
									<td v-if="newOrder.grouping === 1" valign="middle">
										<input type="text" v-model="bt_booklets" class="input-add-beneficiary booklet" />
									</td>
									<td v-if="newOrder.grouping === 1" valign="middle"
										class="priority-1 ticketMessageLabel">
										<input type="text" v-model="bt_ticketMessage" maxlength="30"
											class="input-add-beneficiary message" />
									</td>
									<td :class="newOrder.grouping === 1 ? 'priority-2' : ''" valign="middle">
										<select class="input-add-beneficiary filtrare" v-model="bt_deliveryAddresses">
											<option v-for="(delivery, index) in deliveryAddresses" :key="index"
												:value="delivery.codcom">
												{{
													getAddressName(delivery)

												}}
											</option>
										</select>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-2" valign="middle">
										<span class="currencyinput">
											<input type="text" v-model="bt_amount" v-on:blur="
												bt_amount = convertValueToDecimalVariable(bt_amount)
												" class="input-add-beneficiary amount" />
										</span>
									</td>
									<td class="priority-3" valign="middle">
										<input type="text" v-model="bt_numberOfTickets1"
											class="input-add-beneficiary numberOfTicket" />
									</td>
									<td class="priority-3" valign="middle">
										<span class="currencyinput">
											<span v-html="$t('currency')"></span>
											&nbsp;
											<input type="text" v-model="bt_amount1" class="input-add-beneficiary amount"
												v-on:blur="
													bt_amount1 = convertValueToOneDecimalVariable(bt_amount1)
													" />
										</span>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-5" valign="middle">
										<input type="text" v-model="bt_numberOfTickets2"
											class="input-add-beneficiary numberOfTicket" />
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-5" valign="middle">
										<span class="currencyinput">
											<span v-html="$t('currency')"></span>
											&nbsp;
											<input type="text" v-model="bt_amount2" class="input-add-beneficiary amount"
												v-on:blur="
													bt_amount2 = convertValueToOneDecimalVariable(bt_amount2)
													" />
										</span>
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-6" valign="middle">
										<input type="text" v-model="bt_numberOfTickets3"
											class="input-add-beneficiary numberOfTicket" />
									</td>
									<td v-if="newOrder.grouping === 1" class="priority-6" valign="middle">
										<span class="currencyinput">
											<span v-html="$t('currency')"></span>
											&nbsp;
											<input type="text" v-model="bt_amount3" class="input-add-beneficiary amount"
												v-on:blur="
													bt_amount3 = convertValueToOneDecimalVariable(bt_amount3)
													" />
										</span>
									</td>

									<td>
										<a @click="addBeneficiary()" class="custom-font-awesome">
											<font-awesome-icon icon="plus-circle" />
										</a>
									</td>
								</tr>
								<tr v-show="openAddBeneficiary">
									<td colspan="100">
										<p v-if="newOrder.grouping === 1" class="priority-show-1">
											<strong>{{ $t("beneficiaryVoucherLabel") }}:
												&nbsp;&nbsp;</strong>
											<input type="text" v-model="bt_ticketMessage" maxlength="30"
												class="input-add-beneficiary message" />
										</p>
										<p v-if="newOrder.grouping === 1" class="priority-show-2">
											<strong>{{ $t("deliveryPointLabel") }}: &nbsp;&nbsp;</strong>
											<select class="input-add-beneficiary filtrare" v-model="bt_deliveryAddresses">
												<option v-for="(delivery, index) in deliveryAddresses" :key="index"
													:value="delivery.codcom">
													{{
														getAddressName(delivery)

													}}
												</option>
											</select>
										</p>
										<p class="priority-show-2" valign="middle">
											<strong>{{
												$t("amountVoucherLabelPaper")
											}}&nbsp;&nbsp;</strong>
											&nbsp;
											<span class="currencyinput">
												<span v-html="$t('currency')"></span>
												&nbsp;
												<input type="text" v-model="bt_amount" v-on:blur="
													bt_amount = convertValueToDecimalVariable(
														bt_amount
													)
													" class="input-add-beneficiary amount" />
											</span>
										</p>
										<p class="priority-show-3">
											<strong>{{
												$t("noTicketsValue1Label" + newOrder.grouping)
											}}
												&nbsp;&nbsp;</strong>
											<input type="text" v-model="bt_numberOfTickets1"
												class="input-add-beneficiary" />
										</p>
										<p class="priority-show-3">
											<strong>{{
												$t("amountVoucher1Label" + newOrder.grouping)
											}}</strong>&nbsp;
											<span class="currencyinput">
												<span v-html="$t('currency')"></span>
												&nbsp;
												<input type="text" v-model="bt_amount1" class="input-add-beneficiary amount"
													v-on:blur="
														bt_amount1 = convertValueToDecimalVariable(bt_amount1)
														" />
											</span>
										</p>
										<p v-if="newOrder.grouping === 1" class="priority-show-5">
											<strong>{{ $t("noTicketsValue2Label") }} &nbsp;&nbsp;</strong>
											<input type="text" v-model="bt_numberOfTickets2"
												class="input-add-beneficiary" />
										</p>
										<p v-if="newOrder.grouping === 1" class="priority-show-5">
											<strong>{{ $t("amountVoucher2Label") }}</strong>&nbsp;
											<span class="currencyinput">
												<span v-html="$t('currency')"></span>
												&nbsp;
												<input type="text" v-model="bt_amount2" disabled
													class="input-add-beneficiary amount" v-on:blur="
														bt_amount2 = convertValueToDecimalVariable(bt_amount2)
														" />
											</span>
										</p>
										<p v-if="newOrder.grouping === 1" class="priority-show-6">
											<strong>{{ $t("noTicketsValue3Label") }} &nbsp;&nbsp;</strong>
											<input type="text" v-model="bt_numberOfTickets3"
												class="input-add-beneficiary" />
										</p>
										<p v-if="newOrder.grouping === 1" class="priority-show-6">
											<strong>{{ $t("amountVoucher3Label") }}</strong>&nbsp;
											<span class="currencyinput">
												<span v-html="$t('currency')"></span>
												&nbsp;
												<input type="text" v-model="bt_amount3" class="input-add-beneficiary amount"
													v-on:blur="
														bt_amount3 = convertValueToDecimalVariable(bt_amount3)
														" />
											</span>
										</p>
									</td>
								</tr>
								<template v-for="(entry, index) in this.customerBeneficiaries">
									<tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
										<td valign="middle">
											<a @click="selectBeneficiaryMobile(index)"
												class="detailsOrderMobile display-inline-block" :class="newOrder.grouping === 1
													? 'priority-show-6'
													: 'priority-show-3'
													">
												<font-awesome-icon icon="minus-circle" v-if="(detailsMobile && entry === selectedBeneficiary) ||
													entry.newBeneficiary
													" />
												<font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
											</a>
											<span class="crt">&nbsp;&nbsp;{{ index + 1 }}</span>
										</td>
										<td v-if="newOrder.grouping === 1" valign="middle">
											{{ entry.booklets }}
										</td>
										<td v-if="newOrder.grouping === 1" class="priority-1" valign="middle">
											{{ entry.first_name }}
										</td>
										<td :class="newOrder.grouping === 1 ? 'priority-2' : ''" valign="middle">
											<span>{{ getAddressDisplayName(entry.address) }}</span>
										</td>
										<td v-if="newOrder.grouping === 1" class="priority-2" valign="middle">
											&nbsp;{{ getTotalAmountForPaper(entry) | toCurrency }}
										</td>
										<td class="priority-3" valign="middle">
											{{ entry.vouchers }}
										</td>
										<td class="priority-3" valign="middle">
											<span>
												&nbsp;{{ entry.nominal_value | toCurrency }}
											</span>
										</td>
										<td v-if="newOrder.grouping === 1" class="priority-5" valign="middle">
											{{ entry.vouchers1 }}
										</td>
										<td v-if="newOrder.grouping === 1" class="priority-5" valign="middle">
											<span>
												&nbsp;{{ entry.nominal_value1 | toCurrency }}
											</span>
										</td>
										<td v-if="newOrder.grouping === 1" class="priority-6" valign="middle">
											{{ entry.vouchers2 }}
										</td>
										<td v-if="newOrder.grouping === 1" class="priority-6" valign="middle">
											<span>
												&nbsp;{{ entry.nominal_value2 | toCurrency }}
											</span>
										</td>

										<td valign="middle">
											<a v-if="entry.newBeneficiary" @click="deleteBeneficiary(index)"
												class="custom-font-awesome">
												<font-awesome-icon icon="minus-circle" />
											</a>
										</td>
									</tr>
									<tr :key="customerBeneficiaries.length + index" class="child"
										:class="index % 2 === 0 && 'gri-cell'"
										v-show="detailsMobile && entry === selectedBeneficiary">
										<td colspan="100">
											<p v-if="newOrder.grouping === 1">
												<strong>{{ $t("beneficiaryVoucherLabel") }} :
													&nbsp;&nbsp;</strong>
												<span>{{ entry.first_name }}</span>
											</p>
											<p v-if="newOrder.grouping === 1" class="priority-show-2">
												<strong>{{ $t("deliveryPointLabel") }} : &nbsp;&nbsp;</strong>
												<span>{{ getAddressDisplayName(entry.address) }}</span>
											</p>
											<p v-if="newOrder.grouping === 1" class="priority-show-2">
												<strong>{{ $t("amountVoucherLabelPaper") }} :
													&nbsp;&nbsp;</strong>
												<span>{{ getTotalAmountForPaper(entry) }}</span>
											</p>
											<p class="priority-show-3">
												<strong>{{
													$t("noTicketsValue1Label" + newOrder.grouping)
												}}
													: &nbsp;&nbsp;</strong>
												<span>{{ entry.vouchers }}</span>
											</p>
											<p class="priority-show-3">
												<strong>{{ $t("amountVoucher1Label" + newOrder.grouping) }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.nominal_value | toCurrency }}
												</span>
											</p>
											<p v-if="newOrder.grouping === 1" class="priority-show-5">
												<strong>{{ $t("noTicketsValue2Label") }} :
													&nbsp;&nbsp;</strong>
												<span>{{ entry.vouchers1 }}</span>
											</p>
											<p v-if="newOrder.grouping === 1" class="priority-show-5">
												<strong>{{ $t("amountVoucher2Label") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.nominal_value1 | toCurrency }}
												</span>
											</p>
											<p v-if="newOrder.grouping === 1" class="priority-show-6">
												<strong>{{ $t("noTicketsValue3Label") }} :
													&nbsp;&nbsp;</strong>
												<span>{{ entry.vouchers2 }}</span>
											</p>
											<p v-if="newOrder.grouping === 1" class="priority-show-6">
												<strong>{{ $t("amountVoucher3Label") }} :
													&nbsp;&nbsp;</strong>
												<span>
													&nbsp;{{ entry.nominal_value2 | toCurrency }}
												</span>
											</p>
										</td>
									</tr>
								</template>
								<tr v-if="this.customerBeneficiaries === null && this.orderType !== 'PAPER'">
									<td colspan="5">
										<div class="loading">
											<img src="@/assets/images/loading.gif" />
										</div>
									</td>
								</tr>

								<tr v-if="this.customerBeneficiaries && this.customerBeneficiaries.size === 0">
									<td colspan="5">{{ $t("noBeneficiariesInfoMessage") }}</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
				<br />
			</div>
			<br />

			<div v-if="isOrderProductHoliday">
				<h5 v-html='$t("productHolidayInfo")'></h5>
			</div>

			<a href="#" class="notification-action-small" @click="goToSummary(false)">
				{{ $t("nextStepButtonLabel") }}
			</a>

		</div>

		<!-- order step 4, summary -->
		<div v-if="this.orderStep === 4">
			<p>
				<strong>{{ $t("details") }}</strong>
			</p>
			<div class="container-alb">
				<table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
					<tr class="trhover">
						<td>
							<strong>{{ $t("orderDetailsAddressLabel") }}</strong>
							{{ customer.address }}
						</td>
					</tr>
					<tr class="gri-cell trhover">
						<td>
							<strong>{{ $t("orderDetailsProductLabel") }}</strong>
							{{ getProductNameMethod(newOrder.product) }}
						</td>
					</tr>
					<tr class="trhover" v-if="newOrder.type === 'NEW' || newOrder.type === 'NEWCR'">
						<td>
							<strong>{{ $t("orderDetailsNoCardsLabel") }}</strong>
							{{ confirmationOrder.total_cards }}
						</td>
					</tr>
					<!-- <tr class="gri-cell trhover" v-if="this.newOrder.type !== 'NEW'">
            <td>
              <strong>{{ $t("orderDetailsNoTicketsLabel") }}</strong>
              {{ confirmationOrder.total_vouchers }}
            </td>
          </tr>-->
					<tr class="gri-cell trhover" v-if="newOrder.type !== 'NEW'">
						<td>
							<strong>{{ $t("orderDetailsNominalValueLabel") }}</strong>
							<span>
								{{ confirmationOrder.total_nominal_value | toCurrency }}
							</span>
						</td>
					</tr>
					<tr class="trhover" v-if="newOrder.type === 'NEWCR'">
						<td>
							<strong>{{ $t("orderValidFromLabel") }}</strong>
							{{ this.getDisplayDate(confirmationOrder.charge_date) }}
						</td>
					</tr>
					<tr>
						<td colspan="6">
							<strong>
								<span v-html="$t('orderCardMessage')" />
							</strong>
						</td>
					</tr>
				</table>
			</div>
			<div class="container-alb moverflow">
				<table cellpadding="10" cellspacing="0" width="95%" align="center">
					<tr>
						<td>
							<h3>{{ $t("beneficiariesName") }}</h3>
						</td>
					</tr>
				</table>

				<table id="test" cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
					<tr>
						<th valign="middle">
							<strong>{{ $t("noCrtLabel") }}</strong>
						</th>
						<th valign="middle" v-if="newOrder.type == 'PAPER'">
							<strong>{{ $t("noOfBookletLabel") }}</strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>
						<th valign="middle" v-if="!isOrderProductReward">
							<strong>
								<strong>{{
									newOrder.type === "PAPER"
									? $t("beneficiaryVoucherLabel")
									: $t("beneficiariesTableSurname")
								}}</strong>&nbsp; </strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>

						<th valign="middle" v-if="newOrder.type !== 'PAPER' && !isOrderProductReward">
							<strong>{{ $t("beneficiariesTableName") }}</strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>

						<th valign="middle" v-if="isOrderProductReward">
							<strong>{{ $t("displayTextLabel") }}</strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>
						<th class="priority-0" valign="middle" v-if="newOrder.type !== 'PAPER' && !isOrderProductReward">
							<strong v-html="$t('employeeIdCardLabel')"></strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>
						<th class="priority-1" valign="middle" v-if="!newOrder.virtual">
							<strong>{{ $t("beneficiariesTableAddress") }}</strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>
						<th class="priority-1" valign="middle" v-if="newOrder.virtual">
							<strong>{{ $t("beneficiariesTableMobile") }}</strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>
						<th class="priority-1" valign="middle" v-if="newOrder.virtual">
							<strong>{{ $t("beneficiariesTableEmail") }}</strong>&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>
						<th class="priority-2" valign="middle" v-if="newOrder.type !== 'PAPER'">
							<strong>{{ $t("beneficiariesTableTicketValue") }}</strong>
							&nbsp;
							<!-- <img src="@/assets/images/arrow-down-fill.svg" /> -->
						</th>
						<th class="priority-2" valingn="middle" v-if="newOrder.type === 'PAPER'">
							<strong>{{
								$t("amountVoucherLabelPaper")
							}}</strong>
						</th>
						<th valign="middle" class="priority-2" v-if="newOrder.type === 'PAPER'">
							<strong>{{
								$t("noTicketsValue1Label" + newOrder.grouping)
							}}</strong>
						</th>
						<th valign="middle" class="priority-2" v-if="newOrder.type === 'PAPER'">
							<strong>{{
								$t("amountVoucher1Label" + newOrder.grouping)
							}}</strong>
						</th>
						<th valign="middle" class="priority-3" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
							<strong>{{ $t("noTicketsValue2Label") }}</strong>
						</th>
						<th valign="middle" class="priority-3" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
							<strong>{{ $t("amountVoucher2Label") }}</strong>
						</th>
						<th valign="middle" class="priority-4" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
							<strong>{{ $t("noTicketsValue3Label") }}</strong>
						</th>
						<th valign="middle" class="priority-4" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
							<strong>{{ $t("amountVoucher3Label") }}</strong>
						</th>
						<th valign="middle" class="priority-4" v-if="isOrderProductReward && !newOrder.virtual">
							<strong>{{ $t("windowText1") }}</strong>
						</th>
						<th valign="middle" class="priority-4" v-if="isOrderProductReward && !newOrder.virtual">
							<strong>{{ $t("windowText2") }}</strong>
						</th>
						<th valign="middle" class="priority-4" v-if="isOrderProductReward && !newOrder.virtual">
							<strong>{{ $t("windowText3") }}</strong>
						</th>
						<th valign="middle" class="priority-4" v-if="isOrderProductReward && !newOrder.virtual">
							<strong>{{ $t("windowText4") }}</strong>
						</th>
					</tr>
					<template v-for="(detail, index) in this.filterDetailsSummary">
						<tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
							<td>
								<a @click="selectBeneficiaryMobile(index)"
									class="detailsOrderMobile priority-show-3 display-inline-block" :class="detail.beneficiary_address &&
										(detail.beneficiary_address.street_name ||
											detail.beneficiary_address.street_detail ||
											detail.beneficiary_address.locality ||
											detail.beneficiary_address.postal_code)
										? 'priority-show-7'
										: 'priority-show-3'
										">
									<font-awesome-icon icon="minus-circle"
										v-if="detailsMobile && detail === selectedBeneficiary" />
									<font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
								</a>
								<span class="crt">&nbsp;&nbsp;{{ isOrderProductReward ? detail.cards : index + 1 }}</span>
							</td>
							<td valign="middle" v-if="newOrder.type === 'PAPER'">
								{{ detail.booklets }}
							</td>
							<td valign="middle" v-if="!isOrderProductReward">{{ detail.first_name }}</td>
							<td valign="middle" v-if="newOrder.type !== 'PAPER' && !isOrderProductReward">
								{{ detail.last_name }}
							</td>
							<td valign="middle" v-if="isOrderProductReward">
								{{ detail.first_name + ' ' + detail.last_name }}
							</td>
							<td class="priority-0" valign="middle"
								v-if="newOrder.type !== 'PAPER' && !isOrderProductReward">
								{{ detail.from_source_id }}
							</td>
							<td class="priority-1" valign="middle" v-if="!newOrder.virtual">
								{{ detail.address === "0" ? "" : detail.address }}
							</td>
							<td class="priority-1" valign="middle" v-if="newOrder.virtual">
								{{ detail.phone }}
							</td>
							<td class="priority-1" valign="middle" v-if="newOrder.virtual">
								{{ detail.email }}
							</td>
							<td class="priority-3" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
								<div>
									{{ getTotalAmountForPaper(detail) | toCurrency }}
								</div>
							</td>
							<td class="priority-2" valign="middle" v-if="newOrder.type !== 'PAPER'">
								<div>
									{{ detail.nominal_value | toCurrency }}
								</div>
							</td>
							<td class="priority-2" v-if="newOrder.type === 'PAPER'">
								{{ detail.vouchers }}
							</td>
							<td class="priority-2" v-if="newOrder.type === 'PAPER'">
								<div>
									{{ detail.nominal_value | toCurrency }}
								</div>
							</td>

							<td class="priority-2" v-if="newOrder.type === 'PAPER'">
								{{ detail.vouchers1 }}
							</td>
							<td class="priority-3" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
								<div>
									{{ detail.nominal_value1 | toCurrency }}
								</div>
							</td>

							<td class="priority-2" v-if="newOrder.type === 'PAPER'">
								{{ detail.vouchers2 }}
							</td>
							<td class="priority-4" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
								<div>
									{{ detail.nominal_value2 | toCurrency }}
								</div>
							</td>
							<td class="priority-4" valign="middle" v-if="isOrderProductReward && !newOrder.virtual">
								{{ detail.beneficiary_address.street_name }}
							</td>
							<td class="priority-4" valign="middle" v-if="isOrderProductReward && !newOrder.virtual">
								{{ detail.beneficiary_address.street_detail }}

							</td>
							<td class="priority-4" valign="middle" v-if="isOrderProductReward && !newOrder.virtual">
								{{ detail.beneficiary_address.locality }}

							</td>
							<td class="priority-4" valign="middle" v-if="isOrderProductReward && !newOrder.virtual">
								{{ detail.beneficiary_address.postal_code }}

							</td>
						</tr>
						<tr :key="index + confirmationOrder.details.length" class="child"
							:class="index % 2 === 0 && 'gri-cell'" v-show="detailsMobile && detail === selectedBeneficiary">
							<td colspan="100">
								<p class="priority-show-0" v-if="newOrder.type !== 'PAPER'">
									<strong v-html="$t('employeeIdCardLabel')">:</strong>&nbsp;&nbsp;
									<span>{{ detail.from_source_id }}</span>
								</p>
								<p class="priority-show-1">
									<strong>{{ $t("beneficiariesTableAddress") }} :
										&nbsp;&nbsp;</strong>
									<span>{{
										detail.address === "0" ? "" : detail.address
									}}</span>
								</p>
								<p v-if="newOrder.type !== 'PAPER'" class="priority-show-2">
									<strong>{{ $t("beneficiariesTableTicketValue") }} :
										&nbsp;&nbsp;</strong>
									<span>{{ detail.nominal_value }}</span>
								</p>
								<p class="priority-show-2" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
									<strong>{{ $t("amountVoucher2Label2") }} &nbsp;&nbsp;</strong>
									<span>
										<div>
											{{ getTotalAmountForPaper(detail) | toCurrency }}
										</div>
									</span>
								</p>
								<p class="priority-show-2" v-if="newOrder.type === 'PAPER'">
									<strong>{{
										$t("noTicketsValue1Label" + newOrder.grouping)
									}}
										&nbsp;&nbsp;</strong>
									<span>{{ detail.vouchers }}</span>
								</p>
								<p class="priority-show-2" v-if="newOrder.type === 'PAPER'">
									<strong>{{
										$t("amountVoucher1Label" + newOrder.grouping)
									}}
										&nbsp;&nbsp;</strong>
									<span>
										<div>
											{{ detail.nominal_value | toCurrency }}
										</div>
									</span>
								</p>
								<p class="priority-show-3" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
									<strong>{{ $t("noTicketsValue2Label") }} &nbsp;&nbsp;</strong>
									<span>{{ detail.vouchers1 }}</span>
								</p>
								<p class="priority-show-3" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
									<strong>{{ $t("amountVoucher2Label") }} &nbsp;&nbsp;</strong>
									<span>
										<div>
											{{ detail.nominal_value1 | toCurrency }}
										</div>
									</span>
								</p>
								<p class="priority-show-4" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
									<strong>{{ $t("noTicketsValue3Label") }} &nbsp;&nbsp;</strong>
									<span>{{ detail.vouchers2 }}</span>
								</p>
								<p class="priority-show-4" v-if="newOrder.type === 'PAPER' && newOrder.grouping === 1">
									<strong>{{ $t("amountVoucher3Label") }} &nbsp;&nbsp;</strong>
									<span>
										<div>
											{{ detail.nominal_value2 | toCurrency }}
										</div>
									</span>
								</p>
								<div v-if="detail.beneficiary_address && !newOrder.virtual">
									<p class="priority-show-7 ">
									<table class="hover-table">
										<tr>
											<td class="table-mobile">
												<strong>{{ $t("beneficiariesTableAddress1") }} :
													&nbsp;&nbsp;</strong>
												<input type="text" v-model="detail.beneficiary_address.street_name"
													class="input-add-beneficiary" />
											</td>
											<td class="table-mobile">
												<strong>{{ $t("beneficiariesTableAddress2") }} :
													&nbsp;&nbsp;</strong>
												<input type="text" v-model="detail.beneficiary_address.street_detail"
													class="input-add-beneficiary" />
											</td>
											<td class="table-mobile">

												<strong>{{ $t("beneficiariesTableAddressCity") }} :
													&nbsp;&nbsp;</strong>
												<input type="text" v-model="detail.beneficiary_address.locality"
													class="input-add-beneficiary" />
											</td>
											<td class="table-mobile">

												<strong>{{ $t("beneficiariesTableAddressPostalCode") }} :
													&nbsp;&nbsp;</strong>
												<input type="text" v-model="detail.beneficiary_address.postal_code"
													class="input-add-beneficiary" />
											</td>
										</tr>
									</table>

									</p>
								</div>
							</td>
						</tr>
					</template>
				</table>
			</div>
			<br />
			<div v-if="isOrderProductHoliday">
				<h5 v-html='$t("productHolidayInfo")'></h5>
			</div>
			<div class="d-flex">
				<a href="#" class="notification-action-small" @click="confirmOrder()">
					{{ $t("nextStepButtonLabel") }}
				</a>

				<a href="#" class="notification-action-small" v-if="onlyForAdmin(userRole)" @click="saveOrder()">
					{{ $t("saveOrderButtonLabel") }}
				</a>
			</div>
		</div>

		<!-- order step 5 congrats ; proform download -->
		<div v-if="this.orderStep === 5">
			<p align="center" v-html="$t('orderSuccessMessage')"></p>
			<div v-if="this.confirmationOrder.simulation === true && this.onlyForAdmin(userRole)">
				<p>
					{{ $t('savedOrderMessage') }}
				</p>
			</div>
			<div v-else>
				<table cellpadding="10" cellspacing="0" class="hover-table delivery" align="center">
					<tr>
						<td width="50%" v-if="!this.confirmationOrder.has_virtual_pair">
							<a href="#" class="notification-action" @click="payOrder()">
								{{ $t("paymentButtonLabel") }}</a>
						</td>
						<td width="50%">
							<a href="/customer/orders" class="notification-action ">{{ $t("ordersButtonLabel") }}</a>
						</td>
					</tr>
				</table>
				<br />

				<OrderDetailsSummary v-if="!this.confirmationOrder.has_virtual_pair" :order="this.confirmationOrder" />
				<p v-else>
					{{ $t('splitOrderMessage') }}
				</p>
				<br />
			</div>


		</div>

		<div id="modal_popup_loading_newOrder" class="modal-popup">
			<div class="modal-popup-content">
				<img src="@/assets/images/loading.gif" />
				<p v-html="$t('loadingPopupMessage')">
				</p>
				<p class="offer-discount"
					v-if="this.confirmationOrder && this.confirmationOrder.total_cards > 350 && this.orderStep == 4"
					v-html="$t('bigOrderMessage')">

				</p>
			</div>
		</div>
		<div v-if="this.onlyForAdmin(userRole)" id="modal_popup_date" class="modal-popup">
			<div class="modal-popup-content orders-popup">
				<a @click="showModalPopup('modal_popup_date', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<h3>{{ $t("orderPurchaseOrderTitle") }}</h3>
				<p>
					<input type="text" v-model="newOrder.purchaseOrder" class="input-add-beneficiary" maxlength="20" />
				</p>
				<h3>{{ $t("orderGeneralCommentTitle") }}</h3>
				<p>
					<input type="text" v-model="newOrder.generalComment" class="input-add-beneficiary" maxlength="50" />
				</p>
				<br />
				<div class="d-flex justify-content-between">
					<div>
						<p @click="changeProformaType('NONE')" :class="this.proformaType === 'NONE' && 'selected'"
							v-html="$t('proformaType_NONE')"></p>
						<p @click="changeProformaType('VALIDFROM')" v-if="this.newOrder.type !== 'PAPER'"
							:class="this.proformaType === 'VALIDFROM' && 'selected'" v-html="$t('proformaType_VALIDFROM')">
						</p>
						<p @click="changeProformaType('POSTPONE')" :class="this.proformaType === 'POSTPONE' && 'selected'"
							v-html="$t('proformaType_POSTPONE')"></p>
					</div>
					<div>
						<div v-if="this.newOrder.type !== 'PAPER' && this.proformaType === 'VALIDFROM'">
							<h3>{{ $t("orderValidFromTitle") }}</h3>
							<p>
								<strong>{{ $t("orderValidFromLabel") }} :</strong>
								<date-range ref="dateOrder" class="invoices-filter" :noRanges="true" :single="true"
									:time="this.period" :minDateOrder="this.minDateOrd" @close="changeValidDate" />
							</p>
						</div>
						<div v-if="this.proformaType === 'POSTPONE'">
							<h3>{{ $t("orderProformaDateTitle") }}</h3>
							<p>
								<strong>{{ $t("orderProformaDateLabel") }} :</strong>
								<date-range ref="proformaDateOrder" class="invoices-filter" :noRanges="true" :single="true"
									:time="this.periodProforma" :minDateOrder="this.minDateOrd"
									@close="changeProformaDate" />
							</p>
						</div>
					</div>
				</div>

				<a href="#" class="notification-action" @click="goToSummary(true)">{{
					$t("nextStepButtonLabel")
				}}</a>
			</div>
		</div>
		<div v-else id="modal_popup_date" class="modal-popup">
			<div class="modal-popup-content orders-popup">
				<a @click="showModalPopup('modal_popup_date', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<h3>{{ $t("orderPurchaseOrderTitle") }}</h3>
				<p>
					<input type="text" v-model="newOrder.purchaseOrder" class="input-add-beneficiary" />
				</p>
				<h3>{{ $t("orderGeneralCommentTitle") }}</h3>
				<p>
					<input type="text" v-model="newOrder.generalComment" class="input-add-beneficiary" max="50" />
				</p>
				<div>
					<div v-if="this.newOrder.type !== 'PAPER'">
						<h3>{{ $t("orderValidFromTitle") }}</h3>
						<p>
							<strong>{{ $t("orderValidFromLabel") }} :</strong>
							<date-range ref="dateOrder" class="invoices-filter" :noRanges="true" :single="true"
								:time="this.period" :minDateOrder="this.minDateOrd" @close="changeValidDate" />
						</p>
					</div>
				</div>

				<a href="#" class="notification-action" @click="goToSummary(true)">{{
					$t("nextStepButtonLabel")
				}}</a>
			</div>
		</div>
		<div v-if="productLogo" id="modal_popup_openLogo" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_openLogo', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<img :src="'http://staging.uphellas.gr/img/paper/' + productLogo + '.jpg'" />
			</div>
		</div>
		<div id="modal_popup_product_info" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_product_info', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>

				<p v-html="$t('noProductContract')"></p>
			</div>
		</div>
		<div id="modal_popup_product_holiday" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_product_holiday', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>

				<p v-html="$t('productHolidayInfo')"></p>
			</div>
		</div>
		<div id="modal_popup_millesime" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_millesime', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>

				<p v-html="$t('millesimeMesage')"></p>
			</div>
		</div>

		<iris-pay-modal-popup v-if="customer" :order="confirmationOrder" :customerId="customer.company_id" />
		<div id="modal_popup_info" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_info', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-if="this.error" v-html="$t('errorActionBeneficiary_' + this.error.code)"></p>

				<div v-if="this.actionOrderErrors" class="error-scroll">
					<p v-for="(error, index) in this.actionOrderErrors" :key="index" class="trhover"
						:class="index % 2 === 0 && 'gri-cell'" v-html="$t(error.error_code, {
							name: error.from_source_id,
							field: $t(error.description),
						})">
					</p>
				</div>
				<p v-if="this.orderStep >= 4 && !this.error" v-html="$t('actionUploadFileSuccess')"></p>
				<!-- <p v-if="this.newOrder.successLink && this.orderStep === 4" v-html="$t('actionUploadFileSuccess')"></p> -->
			</div>
		</div>
	</div>
	<div v-else>

		<!-- <h2 v-html="$t('millesimeMesage')"></h2> -->
	</div>
</template>

<script>
import products from "@/assets/json/products.js";
import httpServiceCompany from "@/http/http-user.js";
import httpServiceCustomer from "@/http/http-customer.js";
import utils from "@/plugins/utils.js";
import validator from "@/plugins/fieldValidation.js";
import Cookies from "js-cookie";
import $ from "jquery";
import { saveAs } from "file-saver";
import { BContainer, BRow, BCol, BFormFile } from "bootstrap-vue";
import OrdersTableDesktop from "./OrdersTableDesktop.vue";
import OrderDetailsSummary from "@/components/company/customer/OrderDetailsSummary.vue";
import IrisPayModalPopup from "../IrisPayModalPopup.vue";
import moment from "moment";
import DateRange from "@/components/DateRange.vue";


export default {
	props: {
		customer: Object,
		userRole: String,
		user: Object,
		msg: String,
	},
	components: {
		"b-container": BContainer,
		"b-row": BRow,
		"b-col": BCol,
		"b-form-file": BFormFile,
		OrdersTableDesktop,
		OrderDetailsSummary,
		IrisPayModalPopup,
		DateRange,
	},
	data() {
		return {
			bigOrderCards: 350,
			fileReceived: null,
			deliveryAddresses: null,
			customerBeneficiaries: null,
			keyword: "",
			lastKeyword: "",
			filterIndex: 0,
			newOrder: {
				type: "",
				product: null,
				deliveryAddress: null,
				content: null,
				customer_id: this.customer.company_id,
				successLink: null,
				virtual: false,
				// chargeMonth: 0,
				validFrom: null,
				personalized: true,
				grouping: 1,
				fileUploaded: false,
				excelColumns: [
					{ index: 1, code: 2 },
					{ index: 2, code: 3 },
					{ index: 3, code: 9 },
					{ index: 4, code: 0 },
					{ index: 5, code: 0 },
					{ index: 6, code: 0 },
					{ index: 7, code: 0 },
					{ index: 8, code: 0 },
					{ index: 9, code: 0 },
					{ index: 10, code: 0 },
				],
				previousOrder: null,
			},
			proformaType: "NONE",
			confirmationOrder: null,
			orderStep: 1, // 1 - CHOOSE ACTION,
			orderType: "", // NEW, NEWCR, PAPER, DUPLICATE
			token: null,
			sortBy: "first_name",
			reverse: false,
			error: null,
			actionOrderErrors: null,
			// newtype: ["PAPER", "NEW", "NEWCR", "DUPLICATE"]
			noOfMonths: 12,
			detailsMobile: false,
			selectedBeneficiary: null,
			defaultVouchers: 0,
			defaultTicketValue: 0,
			availableExcelColumns: null,
			numberOfCarnets: "",
			numberOfTickets: "",
			ticketValue: 0,
			newRow: [],
			previousOrders: null,
			newBeneficiary: false,
			b_deliveryAddressExcel: 0,
			b_first_name: "",
			b_last_name: "",
			b_cnp: "",
			b_deliveryAddresses: 1,
			b_mobileNumber: "69",
			b_email: "",
			b_nominal_value: 0,
			b_display_text: "GIFT 4U",
			openAddBeneficiary: false,
			period: [moment()],
			periodProforma: [],
			order_type: true,
			bt_booklets: 1,
			bt_ticketMessage: "",
			bt_deliveryAddresses: 1,
			bt_numberOfTickets1: 0,
			bt_amount: 0.0,
			bt_amount1: 0.0,
			bt_numberOfTickets2: 0,
			bt_amount2: 0.0,
			bt_numberOfTickets3: 0,
			bt_amount3: 0.0,
			b_address1: "",
			b_address2: "",
			b_addressCity: "",
			b_addressPostalCode: "",
			minDateOrd: moment().toDate(),
			millesime_time: [
				moment("2026-10-06T09:20", "YYYY-MM-DDThh:mm:ss"),
				moment("2026-10-06T11:00", "YYYY-MM-DDThh:mm:ss"),
			],
			order_available: true,
		};
	},
	methods: {
		makeNewOrder() {
			this.newOrder = {
				type: "",
				product: null,
				deliveryAddress: null,
				content: null,
				customer_id: this.customer.company_id,
				successLink: null,
				virtual: false,
				// chargeMonth: 0,
				validFrom: null,
				personalized: true,
				grouping: 1,
				fileUploaded: false,
				excelColumns: [
					{ index: 1, code: 1 },
					{ index: 2, code: 2 },
					{ index: 3, code: 3 },
					{ index: 4, code: 0 },
					{ index: 5, code: 0 },
					{ index: 6, code: 0 },
					{ index: 7, code: 0 },
					{ index: 8, code: 0 },
					{ index: 9, code: 0 },
					{ index: 10, code: 0 },
				],
				previousOrder: null,
			};
			this.orderStep = 1;
			this.proformaType = "NONE";
			this.deliveryAddresses = null;
			this.customerBeneficiaries = null;
			this.confirmationOrder = null;
			this.error = null;
			this.actionOrderErrors = null;
		},
		addRow() {
			(this.numberOfCarnets = ""),
				(this.numberOfTickets = ""),
				(this.ticketValue = 0),
				this.newRow.push({
					numberOfCarnets: this.numberOfCarnets,
					numberOfTickets: this.numberOfTickets,
					ticketValue: this.ticketValue,
				});
		},
		addBeneficiary() {
			this.actionOrderErrors = null;

			this.error = null;
			if (this.orderType !== "PAPER") {
				if (this.isOrderProductReward) {
					// if (!this.b_display_text.includes(' ')){
					// 	this.error = {code: "CARD.ERROR.SPACE"};
					// 	this.showModalPopup("modal_popup_info", true);
					// 	return;
					// }
					if (this.convertValueToDecimalVariable(this.b_nominal_value) <= 0) {
						this.error = { code: "VALUE_MANDATORY" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
					let value2 = Number(parseFloat(this.convertValueToDecimalVariable(this.b_nominal_value).replace(" ", "")));
					if (
						value2 > 150.0
					) {
						this.error = { code: "VALUE_MAX_REWARDS" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
				} else {
					if (!validator.validateNameLatin(this.b_first_name)) {
						this.error = { code: "FIRSTNAME" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
					if (!validator.validateNameLatin(this.b_last_name)) {
						this.error = { code: "LASTNAME" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
				}
				let beneficiary = {
					first_name: this.isOrderProductReward
						? this.b_display_text
							.toUpperCase()
							.substring(0, this.b_display_text.indexOf(" "))
						: this.b_first_name.toUpperCase(),
					last_name: this.isOrderProductReward
						? this.b_display_text
							.toUpperCase()
							.substring(this.b_display_text.indexOf(" ") + 1)
						: this.b_last_name.toUpperCase(),
					from_source_id: this.b_cnp,
					nominal_value: this.b_nominal_value,
					newBeneficiary: true,
					cards: this.isOrderProductReward ? this.bt_booklets : 1,
				};
				if (this.newOrder.virtual) {
					if (
						this.b_email !== null &&
						this.b_email.trim() !== "" &&
						this.b_mobileNumber !== null &&
						this.b_mobileNumber !== "" &&
						this.b_mobileNumber !== "69" &&
						this.b_mobileNumber !== 69
					) {
						this.error = { code: "EMAIL_PHONE_UNIQUE" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}

					if (
						this.b_email !== null &&
						this.b_email.length > 0 &&
						!validator.validateEmail(this.b_email)
					) {
						this.error = { code: "EMAIL_INVALID" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
					if (
						this.b_mobileNumber !== null &&
						this.b_mobileNumber !== "69" &&
						this.b_mobileNumber !== "" &&
						!validator.validateMobilePhone(this.b_mobileNumber)
					) {
						this.error = { code: "MOBILE_INVALID" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}

					if (
						this.isOrderProductReward &&
						this.b_mobileNumber !== null &&
						this.b_mobileNumber !== "" &&
						this.b_mobileNumber !== "69" &&
						this.b_mobileNumber !== 69 &&
						this.bt_booklets > 1
					) {
						this.error = { code: "PHONE_UNIQUE" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}

					if (
						(this.b_email === null || this.b_email.trim().length === 0) &&
						(this.b_mobileNumber === null ||
							this.b_mobileNumber === "69" ||
							this.b_mobileNumber === "" ||
							this.b_mobileNumber === 69)
					) {
						this.error = { code: "EMAIL_PHONE_MANDATORY" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}

					beneficiary.email = this.b_email;
					beneficiary.phone =
						this.b_mobileNumber.length > 2 ? this.b_mobileNumber : "";
				} else {
					beneficiary.beneficiary_address = {
						street_name: this.b_address1,
						street_detail: this.b_address2.toUpperCase(),
						locality: this.b_addressCity.toUpperCase(),
						postal_code: this.b_addressPostalCode.toUpperCase(),
					};
					beneficiary.address = this.b_deliveryAddresses;
				}
				if (
					this.customerBeneficiaries &&
					this.customerBeneficiaries.length > 0
				) {
					this.customerBeneficiaries.unshift(beneficiary);
				} else {
					this.customerBeneficiaries = [];
					this.customerBeneficiaries.push(beneficiary);
				}
				this.b_first_name = "";
				this.b_last_name = "";
				this.b_cnp = "";
				this.b_mobileNumber = "69";
				this.b_email = "";
				this.b_nominal_value = this.defaultTicketValue;
				this.b_deliveryAddresses = this.deliveryAddresses[0].codcom;
				this.bt_booklets = 1;
				if (this.isOrderProductReward) {
					this.b_address2 = "GIFT";
					this.b_addressCity = "FOR";
					this.b_addressPostalCode = "YOU";
					this.b_display_text = "GIFT 4U";
				} else {
					this.b_address1 = "";
					this.b_address2 = "";
					this.b_addressCity = "";
					this.b_addressPostalCode = "";
					this.b_display_text = "";
				}
			} else {
				if (this.newOrder.grouping === 1) {
					if (this.convertValueToDecimalVariable(this.bt_amount) > 175.0) {
						this.error = { code: "VALUE_MAX_PAPER" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
					if (
						Number(this.bt_numberOfTickets1) +
						Number(this.bt_numberOfTickets2) +
						Number(this.bt_numberOfTickets3) >
						35
					) {
						this.error = { code: "MAX_TICKETS_BOOKLET" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
				}
				if (!this.customerBeneficiaries) {
					this.customerBeneficiaries = [];
				}
				if (
					Number(this.bt_amount1) > 99 ||
					Number(this.bt_amount2) > 99 ||
					Number(this.bt_amount3) > 99 ||
					Number(this.bt_amount) > 99
				) {
					this.error = { code: "LOAD_VALUE" };
					this.showModalPopup("modal_popup_info", true);
					return;
				}

				this.customerBeneficiaries.push({
					booklets: this.bt_booklets,
					first_name: this.bt_ticketMessage,
					address: this.bt_deliveryAddresses,
					// amount: this.bt_amount,
					vouchers: this.bt_numberOfTickets1,
					nominal_value: this.bt_amount1,
					vouchers1: this.bt_numberOfTickets2,
					nominal_value1: this.bt_amount2,
					vouchers2: this.bt_numberOfTickets3,
					nominal_value2: this.bt_amount3,
					newBeneficiary: true,
				});

				this.bt_booklets = 1;
				this.bt_ticketMessage = "";
				this.bt_deliveryAddresses = this.deliveryAddresses[0].codcom;
				this.bt_amount = 0;
				this.bt_numberOfTickets1 = 0;
				this.bt_amount1 = 0;
				this.bt_numberOfTickets2 = 0;
				this.bt_amount2 = 0;
				this.bt_numberOfTickets3 = 0;
				this.bt_amount3 = 0;
			}
		},
		deleteRow(index) {
			this.newRow.splice(index, 1);
		},
		deleteBeneficiary(index) {
			this.customerBeneficiaries.splice(index, 1);
		},
		updateNumberOfCarnets(event) {
			this.numberOfCarnets = event.target.value;
		},
		updateNumberOfTickets(event) {
			this.numberOfTickets = event.target.value;
		},
		updateTicketValue(event) {
			this.ticketValue = event.target.value;
		},
		selectBeneficiaryMobile(index) {
			if (this.orderType === "PAPER") {
				if (this.orderStep === 4) {
					this.selectedBeneficiary = this.confirmationOrder.details[index];
				} else {
					this.selectedBeneficiary = this.customerBeneficiaries[index];
				}
				// this.selectedBeneficiary = this.confirmationOrder.details[index];
			} else {
				if (this.orderStep === 4) {
					this.selectedBeneficiary = this.confirmationOrder.details[index];
				} else {
					this.selectedBeneficiary = this.customerBeneficiaries[index];
				}
			}
			this.detailsMobile = !this.detailsMobile;
		},
		openAddBeneficiaryMobile() {
			this.openAddBeneficiary = !this.openAddBeneficiary;
		},
		selectOrderType(type) {
			if (type === "PAPER") {
                const now = moment(new Date(), "YYYY-MM-DDThh:mm:ss");
                if (now >= this.millesime_time[0] && now <= this.millesime_time[1]) {
                    this.showModalPopup("modal_popup_millesime", true);
                    return;
                }
			}
			this.newOrder.type = type;
			this.orderType = type;
			this.orderStep = 2;

			this.deliveryAddresses = null;
			this.customerBeneficiaries = null;
			this.newOrder.product = null;
			this.newOrder.deliveryAddress = null;
			this.newOrder.content = null;
			this.newOrder.successLink = null;
			this.newOrder.validFrom = null;
			this.newOrder.fileUploaded = false;
			this.newOrder.virtual = false;

			this.proformaType = "NONE";
			this.confirmationOrder = null;
			this.error = null;
			this.actionOrderErrors = null;
			if (this.orderType === "DUPLICATE") {

				this.selectProduct(this.customer.products[0], false);
			}

		},
		selectProductDuplicate(event) {
			this.selectProduct(this.orderProducts[event.target.value], false);
		},
		isProductAvailable(product) {
			for (var index in this.customer.products) {
				var prod = this.customer.products[index];
				if (
					(prod.card === product.card && prod.card > 0) ||
					(prod.paper === product.paper && prod.paper > 0)
				) {
					if (this.orderType === "DUPLICATE") {
						return true;											
					}else {
						if (this.newOrder.virtual) {
							if (prod.card_profile > 1) {
								return true;
							} else {
								return false;
							}
						} else {
							if (prod.card_profile === 1 || prod.card_profile === 2) {
								return true;
							} else {
								return false;
							}
						}
					}
				}
			}
			return false;
		},
		selectProduct(product, virtual) {
			this.newOrder.virtual = virtual;
			if (!this.isProductAvailable(product)) {
				this.showModalPopup("modal_popup_product_info", true);
				return;
			}

			this.newOrder.product = product;
            if (this.isOrderProductHoliday && this.userRole !== "FAC") {
				this.showModalPopup("modal_popup_product_holiday", true);
				return;
			}
			this.orderStep = 3;
			this.newOrder.personalized = product.perso ? product.perso : true;

			this.deliveryAddresses = null;
			this.b_deliveryAddressExcel = 0;
			this.customerBeneficiaries = null;
			this.newOrder.deliveryAddress = null;
			this.newOrder.content = null;
			this.newOrder.successLink = null;
			this.newOrder.validFrom = null;
			this.newOrder.fileUploaded = false;

			this.proformaType = "NONE";
			this.confirmationOrder = null;
			this.error = null;
			this.actionOrderErrors = null;

			if (this.orderType === "NEWCR" && !this.isOrderProductReward) {
				this.loadCustomerBeneficiaries();
			}
			if (this.orderType === "DUPLICATE") {
				this.orderStep = 2;
				this.newOrder.type = this.newOrder.product.card > 0 ? "CARD" : "PAPER";
				this.getPreviousOrdersForProduct();
			}

			if (this.isOrderProductReward) {
				this.order_type = true;
				this.b_address2 = "GIFT";
				this.b_addressCity = "FOR";
				this.b_addressPostalCode = "YOU";
				this.customerBeneficiaries = [];
			}

			this.getDeliveryAddreses();
		},
		selectGrouping(newGrouping) {
			this.newOrder.grouping = newGrouping;
			this.customerBeneficiaries = [];
		},
		getDeliveryAddreses() {
			var formData = "?per_page=" + 1000 + "&page=" + 1;

			httpServiceCompany.userService
				.getAddressPoints(this.customer.company_id, formData, Cookies.get("token"))
				.then(function (response) {
					// handle success
					return response;
				})
				.then((response) => {
					if (response.status == 200) {
						this.deliveryAddresses = response.data.results;
						if (this.deliveryAddresses.length === 1) {
							this.newOrder.deliveryAddress = this.deliveryAddresses[0].codcom;
						}
						this.bt_deliveryAddresses = this.deliveryAddresses[0].codcom;
						this.b_deliveryAddresses = this.deliveryAddresses[0].codcom;
					} else if (response.status == 400 || response.status == 403) {
						this.deliveryAddresses = null;
					}
				});
		},
		loadCustomerBeneficiaries() {
			this.customerBeneficiaries = null;
			// retreive customer beneficiaries from service
			var formData = "?product=" + this.newOrder.product.card;
			formData += "&brand=" + this.newOrder.product.brand;
			if (
				this.b_deliveryAddressExcel !== null &&
				this.b_deliveryAddressExcel > 0
			) {
				formData += "&coddp=" + this.b_deliveryAddressExcel;
			}
			formData += "&top_up=Y" + "&per_page=" + 10000 + "&page=" + 1;

			httpServiceCustomer.customerService
				.searchCards(formData, this.customer.company_id, this.token)
				.then(function (response) {
					// handle success
					return response;
				})
				.then((response) => {
					if (response.status == 200) {
						let customerBeneficiariesTemp = response.data.results;
						this.customerBeneficiaries = [];

						for (let index in customerBeneficiariesTemp) {
							this.customerBeneficiaries.push({
								from_source_id: customerBeneficiariesTemp[index].cnp,
								first_name: customerBeneficiariesTemp[index].first_name,
								last_name: customerBeneficiariesTemp[index].last_name,
								vouchers: 0,
								nominal_value: this.defaultTicketValue,
							});
						}
						this.customerBeneficiaries = this.filterDetails;
					} else if (response.status == 400 || response.status == 403) {
						this.customerBeneficiaries = null;
					}
				});
		},
		sortPreviousOrdersBy(sortField, sortDirection) {
			this.sortField = sortField;
			this.sortDirection = sortDirection;
			this.getPreviousOrdersForProduct();
		},
		sortOrdersBy(sortField, sortDirection) {
			this.sortField = sortField;
			this.sortDirection = sortDirection;
			this.getPreviousOrdersForProduct();
		},
		getPreviousOrdersForProduct() {
			var ordersData =
				"?product=" +
				(this.newOrder.product.card === 0
					? this.newOrder.product.paper
					: this.newOrder.product.card) +
				"&brand=" +
				this.newOrder.product.brand +
				"&duplicate=Y" +
				"&per_page=10000" +
				"&page=1";
			httpServiceCustomer.customerService
				.searchOrders(
					ordersData,
					this.customer.company_id,
					Cookies.get("token")
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch(function () {
					// handle success
				})
				.then((response) => {
					if (response.status == 200) {
						this.previousOrders = response.data.results;
					} else if (response.status == 400 || response.status == 403) {
						this.orderError = {
							code: response.data,
							description: "Error fetching invoices",
						};
						// return null;
					} else {
						this.orderError = { description: response.description };
						// return null;
					}
				});
		},
		setDefaultValuesForNEWCR() {
			if (this.customerBeneficiaries !== null) {
				for (let index in this.customerBeneficiaries) {
					this.customerBeneficiaries[index].vouchers = this.defaultVouchers;
					this.customerBeneficiaries[index].nominal_value =
						this.defaultTicketValue;
					this.customerBeneficiaries[index].total_nominal_value =
						this.defaultVouchers * this.defaultTicketValue;
				}
			}
		},
		downloadModel() {
			this.showModalPopup("modal_popup_loading_newOrder", true);

			if (this.orderType === "DUPLICATE") {
				httpServiceCustomer.customerService
					.getOrderModelFile(
						this.customer.company_id,
						this.newOrder.previousOrder,
						this.newOrder.type,
						this.token
					)
					.then(function (response) {
						// handle success
						return response;
					})
					.then((response) => {
						if (response.status == 200) {
							var blob = new Blob(
								[this.base64ToArrayBuffer(response.data.content)],
								{
									type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
								}
							);
							saveAs(blob, response.data.name);

							// download content
						}
						this.showModalPopup("modal_popup_loading_newOrder", false);
					});
			} else {
				var formData = {
					product: 0,
					customer_id: this.customer.company_id,
					address_code: this.b_deliveryAddressExcel,
					type:
						this.newOrder.type === "PAPER"
							? "EXNT" + this.newOrder.grouping
							: this.newOrder.type + (this.newOrder.virtual ? "V" : ""),
				};
				if (this.newOrder.type === "PAPER") {
					formData.product = this.newOrder.product.paper;
				} else {
					formData.product = this.newOrder.product.card;
				}
				if (this.newOrder.product.brand === "rewards") {
					formData.alias = "rewards";
				}

				httpServiceCustomer.customerService
					.getOrderTemplateModelFile(
						this.customer.company_id,
						formData,
						this.token
					)
					.then(function (response) {
						// handle success
						return response;
					})
					.then((response) => {
						if (response.status == 200) {
							var blob = new Blob(
								[this.base64ToArrayBuffer(response.data.content)],
								{
									type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
								}
							);
							saveAs(blob, response.data.name);
							// download content
						} else if (response.status == 400 || response.status == 403) {
							this.deliveryAddresses = null;
						}
						this.showModalPopup("modal_popup_loading_newOrder", false);
					});
			}
		},
		changeReverse(sortField) {
			this.sortBy = sortField;
			console.log("changeReverse");
			this.reverse = !this.reverse;
			this.customerBeneficiaries = this.filterDetails;
		},
		base64ToArrayBuffer(base64) {
			var binaryString = window.atob(base64);
			var binaryLen = binaryString.length;
			var bytes = new Uint8Array(binaryLen);
			for (var i = 0; i < binaryLen; i++) {
				var ascii = binaryString.charCodeAt(i);
				bytes[i] = ascii;
			}
			return bytes;
		},
		arrayBufferToBase64(buffer) {
			var binary = "";
			var bytes = new Uint8Array(buffer);
			var len = bytes.byteLength;
			for (var i = 0; i < len; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			return window.btoa(binary);
		},
		uploadFileToServer() {
			this.error = null;
			this.actionOrderErrors = null;
			this.showModalPopup("modal_popup_loading_newOrder", true);
			var orderData = {
				product: 0,
				content: this.newOrder.content,
				customer_id: this.customer.company_id,
				type: this.newOrder.type === "PAPER" ? "EXNT" : this.newOrder.type,
			};

			if (this.newOrder.type === "PAPER") {
				orderData.product = this.newOrder.product.paper;
				orderData.packing = this.newOrder.grouping;
				orderData.message1 = this.newOrder.text1;
				orderData.message2 = this.newOrder.text2;
			} else {
				orderData.product = this.newOrder.product.card;
				orderData.charge_date = this.period[0];
				orderData.virtual = this.newOrder.virtual;
			}

			orderData.brand = this.newOrder.product.brand;

			orderData.external_number = this.newOrder.purchaseOrder;
			orderData.text_on_invoice = this.newOrder.generalComment;
			if (this.periodProforma.length > 0) {
				orderData.proforma_date = this.periodProforma[0];
			}
			httpServiceCustomer.customerService
				.uploadOrderFile(
					this.customer.company_id,
					orderData,
					this.token,
					this.userRole === "FAC" ? this.user.username : null
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch((error) => {
					return error.response;
				})
				.then((response) => {
					if (response.status == 200) {
						let nextLink = response.headers["link"];
						nextLink = nextLink.split(";")[0];
						nextLink = nextLink.replace(">", "");
						nextLink = nextLink.replace("<", "");
						this.confirmationOrder = response.data;
						this.newOrder.successLink = nextLink;
						this.orderStep++;
						this.actionOrderErrors = null;
						
						this.error = null;
						this.showModalPopup("modal_popup_loading_newOrder", false);
						return;
					} else if (response.status === 406) {
						this.error = { code: "MILLESIME" };
					} else {
						this.getResponseErrors(response);
						this.showModalPopup("modal_popup_loading_newOrder", false);
						this.showModalPopup("modal_popup_info", false);
						this.error = { code: "TICKET" };
					}
					this.showModalPopup("modal_popup_loading_newOrder", false);
				})
				
		},
		changeVoucherValueForEntry(event, entry) {
			entry.vouchers = event.value;
			entry.total_nominal_value = entry.vouchers * entry.nominal_value;
		},
		showModalPopup(elementId, show) {
			if (show) {
				document.getElementById(elementId).style.visibility = "visible";
			} else {
				document.getElementById(elementId).style.visibility = "hidden";
			}
		},
		changeValidDate(value) {
			if (value === null) {
				this.period = [moment()];
			} else {
				this.period = value;
			}
		},
		changeProformaDate(value) {
			console.log(value);
			if (value === null) {
				this.periodProforma = [moment()];
			} else {
				this.periodProforma = value;
			}
		},
		changeProformaType(value) {
			this.proformaType = value;
		},
		backOneStep() {
			this.actionOrderErrors = null;
			this.error = null;
			this.orderStep--;
			if (this.orderStep < 2) {
				this.orderType = "";
				this.previousOrders = null;
			}
		},
		getResponseErrors(response) {
			let errorsLink = response.headers["link"];
			if (!errorsLink) {
				this.error = { code: 500 };
				return;
			}
			errorsLink = errorsLink.split(";")[0];
			errorsLink = errorsLink.replace(">", "");
			errorsLink = errorsLink.replace("<", "");
			if (errorsLink.includes("exceptions_type")) {
				httpServiceCustomer.customerService
					.getOrderErrors(errorsLink, this.token)

					.then((response) => {
						if (response.status === 200) {
							this.actionOrderErrors = response.data.errors;
							this.error = { code: "ERROR" };
						}
						this.showModalPopup("modal_popup_info", true);
						this.showModalPopup("modal_popup_loading_newOrder", false);
					})
					.catch((error) => {
						// handle success
						if (error.response.data) {
							this.error = { code: error.response.data.code };

							this.viewDetails(false);
						} else {
							this.error = { code: "500" };
						}
						this.showModalPopup("modal_popup_info", true);
						this.showModalPopup("modal_popup_loading_newOrder", false);
					});
				} else {
					this.showModalPopup("modal_popup_info", true);
					this.showModalPopup("modal_popup_loading_newOrder", false);
				}
		},
		uploadFile() {
			//Validate whether File is valid Excel file.
			if (typeof FileReader != "undefined") {
				var reader = new FileReader();
				reader.onload = () => {
					this.newOrder.content = btoa(reader.result);
				};
				//For Browsers other than IE.
				if (reader.readAsBinaryString) {
					reader.readAsBinaryString(this.fileReceived);
				} else {
					alert("This browser does not support HTML5.");
				}
			}

			if (!this.fileReceived) {
				return;
			}
		},
		searchCustomerBeneficiaries() {
			if (this.lastKeyword == this.keyword) {
				this.filterIndex++;
			} else {
				this.lastKeyword = this.keyword;
				this.filterIndex = 0;
			}
			let items = this.customerBeneficiaries.filter(
				(item) =>
					item.last_name.indexOf(this.keyword.toUpperCase()) > -1 ||
					item.first_name.indexOf(this.keyword.toUpperCase()) > -1 ||
					item.from_source_id.indexOf(this.keyword.toUpperCase()) > -1
			);
			if (this.filterIndex >= items.length) {
				this.filterIndex = 0;
			}
			$("#nominal_value_" + items[this.filterIndex].from_source_id).focus();
		},
		selectOrder(order) {
			this.orderStep = 2;
			this.confirmationOrder = null;
			this.proformaType = "NONE";
			this.error = null;
			this.actionOrderErrors = null;

			this.newOrder.product = utils.getProductById(order.product, this.orderProducts);
			this.newOrder.previousOrder = order.id;
			this.newOrder.type = order.type;
			// this.orderType = order.type;
			if (this.newOrder.type === "NEW") {
				this.newOrder.type = "NEWCR";
			}
			this.getCustomerOrderHeader(order.simulation);
			this.getOrderDetails(order.simulation);
		},
		getCustomerOrderHeader(simulation) {
			httpServiceCustomer.customerService
				.getOrderHeader(
					this.newOrder.previousOrder,
					this.customer.company_id,
					Cookies.get("token"),
					this.newOrder.type === "PAPER" ? "PAPER" : "CARD",
					simulation
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch(function () {
					// handle success
				})
				.then((response) => {
					if (response.status == 200) {
						this.newOrder.grouping = response.data.packing
							? response.data.packing
							: 1;
						this.newOrder.text1 = response.data.message1;
						this.newOrder.text2 = response.data.message2;
						this.newOrder.virtual = response.data.virtual;
						this.newOrder.product = utils.getProductById(response.data.product, this.orderProducts);
						this.newOrder.validFrom = response.data.validFrom;
						this.newOrder.simulation = response.data.simulation;
						this.newOrder.external_id = response.data.external_id;
					} else if (response.status == 400 || response.status == 403) {
						this.orderError = {
							code: response.data,
							description: "Error fetching invoices",
						};
					} else {
						this.orderError = { description: response.description };
					}
				});
		},
		getOrderDetails(simulation) {
			httpServiceCustomer.customerService
				.getOrderDetails(
					this.newOrder.previousOrder,
					this.customer.company_id,
					Cookies.get("token"),
					this.newOrder.type === "PAPER" ? "PAPER" : "CARD",
					simulation
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch((error) => {
					return error.response;
				})
				.then((response) => {
					if (response.status == 200) {
						this.customerBeneficiaries = [];
						response.data.forEach((x) => {
							if (x.badge === 0) {
								if (x.cards == 1) {
									x.newBeneficiary = true;
								}
								this.customerBeneficiaries.push(x);
							}
						});
						this.orderStep++;
					} else if (response.status == 400 || response.status == 403) {
						this.orderError = {
							code: response.data,
							description: "Error fetching details for order " + this.orderId,
						};
					} else {
						this.orderError = { description: response.description };
					}
					this.showModalPopup("modal_popup_loading_newOrder", false);
				});
		},
		uploadListToServer() {
			this.error = null;
			this.actionOrderErrors = null;
			if (this.beneficiariesForSubmit.length === 0) {
				this.error = { code: "EMPTY" };
				this.showModalPopup("modal_popup_info", true);

				this.showModalPopup("modal_popup_loading_newOrder", false);
				return;
			}
			var orderData = {
				product: 0,
				details: this.beneficiariesForSubmit,
				customer_id: this.customer.company_id,
				type: this.newOrder.type === "PAPER" ? "EXNT" : this.newOrder.type,
			};
			this.showModalPopup("modal_popup_loading_newOrder", true);
			if (this.newOrder.type === "PAPER") {
				orderData.product = this.newOrder.product.paper;
				orderData.packing = this.newOrder.grouping;
				orderData.message1 = this.newOrder.text1;
				orderData.message2 = this.newOrder.text2;
			} else {
				orderData.product = this.newOrder.product.card;
				orderData.charge_date = this.period[0];
				orderData.virtual = this.newOrder.virtual;
			}
			orderData.external_number = this.newOrder.purchaseOrder;
			orderData.text_on_invoice = this.newOrder.generalComment;
			if (this.periodProforma.length > 0) {
				orderData.proforma_date = this.periodProforma[0];
			}
			orderData.brand = this.newOrder.product.brand;

			httpServiceCustomer.customerService
				.uploadOrderFile(
					this.customer.company_id,
					orderData,
					this.token,
					this.userRole === "FAC" ? this.user.username : null
				)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch((error) => {
					return error.response;
				})
				.then((response) => {
					if (response.status === 200) {
						let nextLink = response.headers["link"];
						nextLink = nextLink.split(";")[0];
						nextLink = nextLink.replace(">", "");
						nextLink = nextLink.replace("<", "");
						this.confirmationOrder = response.data;
						this.newOrder.successLink = nextLink;
						this.error = null;
						this.actionOrderErrors = null;
						this.orderStep++;
						this.showModalPopup("modal_popup_loading_newOrder", false);
					} else if (response.status === 406) {
						this.showModalPopup("modal_popup_loading_newOrder", false);
						this.showModalPopup("modal_popup_info", true);
						this.error = { code: "MILLESIME" };
					} else {
						this.showModalPopup("modal_popup_loading_newOrder", false);
						this.showModalPopup("modal_popup_info", true);
						this.error = { code: "TICKET" };
						this.getResponseErrors(response);
					}
				});
		},
		goToSummary(fromPopup) {
			if (!fromPopup) {
				this.showModalPopup("modal_popup_date", true);
				// this.$refs.dateOrder.toggle();
				return;
			} else {
				if (this.proformaType === 'POSTPONE' && this.periodProforma.length == 0) {
					this.error = { code: "NO_POSTPONE_DATE" };
					this.showModalPopup("modal_popup_info", true);
					return;
				}
				this.showModalPopup("modal_popup_date", false);
				if (this.order_type) {
					this.newOrder.content = null;
				}
				if (!this.newOrder.content) {
					if (this.customerBeneficiaries) {
						this.uploadListToServer();
					} else {
						this.error = { code: "NO_DATA" };
						this.showModalPopup("modal_popup_info", true);
						return;
					}
				} else {
					this.uploadFileToServer();
				}
			}
		},
		confirmOrder() {
			// confirm customer order if there are no errors
			this.actionOrderErrors = null;
			this.error = null;
			// if (this.confirmationOrder.total_cards < this.bigOrderCards) {
			this.showModalPopup("modal_popup_loading_newOrder", true);
			// } else {
			// 	this.orderStep = 5;
			// }
			httpServiceCustomer.customerService
				.confirmOrder(
					this.newOrder.successLink,
					this.confirmationOrder,
					this.token
				)
				.then((response) => {

					if (response.status === 406) {
						this.error = { code: "MILLESIME" };
						return;
					}
					if (response.status !== 200) {
						this.actionOrderErrors = response.data.errors;
						this.error = { code: "TICKET" };
						return;
					}
					this.orderStep = 5;
					let nextLink = response.headers["link"];
					// nextLink = nextLink.split(";")[0];
					// nextLink = nextLink.replace(">", "");
					// nextLink = nextLink.replace("<", "");
					this.confirmationOrder = response.data;
					this.newOrder.successLink = nextLink;
					this.showModalPopup("modal_popup_loading_newOrder", false);
				})
				.catch((error) => {
					// handle success
					console.log(error);
					if (error.response) {
						if (error.response.data.code) {
							this.error = { code: error.response.data.code };
						} else if (error.response.status === 406) {
							this.error = { code: "MILLESIME" };
						} else {
							this.error = { code: "TICKET" };
						}
					} else {
						this.error = { code: "TICKET" };
					}
					this.showModalPopup("modal_popup_info", true);
					this.showModalPopup("modal_popup_loading_newOrder", false);
				});
		},
		saveOrder() {
			this.confirmationOrder.simulation = true;
			this.confirmOrder();
		},
		payOrder() {
			this.showModalPopup("modal_popup_confirmOrderPay", true);
		},
		convertValueToDecimal() {
			this.defaultTicketValue = parseFloat(
				this.defaultTicketValue.toString().replace(/ /g, "")
			);
			this.b_nominal_value = parseFloat(
				this.b_nominal_value.toString().replace(/ /g, "")
			);
			this.bt_amount1 = parseFloat(
				this.bt_amount1.toString().replace(/ /g, "")
			);
			this.bt_amount2 = parseFloat(
				this.bt_amount2.toString().replace(/ /g, "")
			);
			this.bt_amount3 = parseFloat(
				this.bt_amount3.toString().replace(/ /g, "")
			);

			this.defaultTicketValue = Number(this.defaultTicketValue)
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
			this.b_nominal_value = Number(this.b_nominal_value)
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
			this.bt_amount1 = Number(this.bt_amount1)
				.toFixed(1)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
			this.bt_amount2 = Number(this.bt_amount2)
				.toFixed(1)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
			this.bt_amount3 = Number(this.bt_amount3)
				.toFixed(1)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
		},
		convertValueToDecimalVariable(variable) {
			variable = parseFloat((variable || 0).toString().replace(/ /g, ""));

			variable = Number(variable)
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

			return variable;
		},
		convertValueToOneDecimalVariable(variable) {
			variable = parseFloat((variable || 0).toString().replace(/ /g, ""));

			variable = Number(variable)
				.toFixed(1)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

			return variable;
		},
		mobilePhoneOnlyNumbers(number) {
			if (/^-?\d*$/.test(number)) {
				this.oldValue = number;
				this.oldSelectionStart = this.selectionStart;
				this.oldSelectionEnd = this.selectionEnd;
			} else {
				number = this.oldValue;
			}
			return number;
		},
		getAddressDisplayName(addressCode) {
			for (let index in this.deliveryAddresses) {
				if (this.deliveryAddresses[index].codcom === addressCode) {
					return (
						this.deliveryAddresses[index].codcom +
						" - " +
						this.deliveryAddresses[index].name +
						"(" +
						this.deliveryAddresses[index].address.street_name +
						", " +
						this.deliveryAddresses[index].address.locality
						+ ")"
					);
				}
			}
			return addressCode;
		},
		getAddressName(address) {
			return (
				address.codcom +
				" - " +
				address.name +
				" (" +
				address.address.street_name +
				", " +
				address.address.locality
				+ ")"
			);
		},
		getProductNameMethod(product) {
			return utils.getProductName(
				product.card === 0 ? product.paper : product.card
			);
		},
		getProductNameBrand(brand) {
			return utils.getProductByBrand(brand, this.orderProducts).name;
		},
		getTotalAmountForPaper(beneficiary) {
			return (
				beneficiary.vouchers * beneficiary.nominal_value +
				beneficiary.vouchers1 * beneficiary.nominal_value1 +
				beneficiary.vouchers2 * beneficiary.nominal_value2
			);
		},
		getDisplayDate(date) {
			return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
		},
	},
	computed: {
		paperProducts() {
			let paperProducts = [];
			for (let index in products) {
				if (products[index].paper === 1) {
					paperProducts.push(products[index]);
				}
			}
			return paperProducts;
		},
		cardProducts() {
			let cardProducts = [];
			for (let index in products) {
				if (products[index].card > 0 && (products[index].card !== 13 || this.userRole === "FAC")) {
					cardProducts.push(products[index]);
				}
			}
			return cardProducts;
		},
		orderProducts() {
			if (this.orderType === "PAPER") {
				return this.paperProducts;
			} else if (this.orderType === "NEW" || this.orderType === "NEWCR") {
				return this.cardProducts;
			} else if (this.orderType === "DUPLICATE") {
				let duplicateProducts = [];
				for (let index in products) {
					if (products[index].brand !== "rewards" && products[index].card !== 13) {
						duplicateProducts.push(products[index]);
					}
				}
				return duplicateProducts;
			} else {
				return null;
			}
		},
		filterDetails: function () {
			let result = this.customerBeneficiaries;

			if (result)
				result.sort((a, b) =>
					a[this.sortBy] <= b[this.sortBy]
						? -1
						: a[this.sortBy] !== b[this.sortBy]
				);

			return this.reverse ? result.reverse() : result;
		},
		filterDetailsSummary: function () {
			let result = this.confirmationOrder.details;

			if (result)
				result.sort((a, b) =>
					a[this.sortBy] <= b[this.sortBy]
						? -1
						: a[this.sortBy] !== b[this.sortBy]
				);

			return this.reverse ? result.reverse() : result;
		},
		totalNominalValue: function () {
			let totalValue = 0;
			for (let index in this.customerBeneficiaries) {
				totalValue += parseFloat(
					this.customerBeneficiaries[index].cards
						? this.customerBeneficiaries[index].nominal_value *
						this.customerBeneficiaries[index].cards
						: this.customerBeneficiaries[index].nominal_value
							.toString()
							.replace(/ /g, "")
				);
			}
			return this.convertValueToDecimalVariable(totalValue);
		},
		totalNumberOfBeneficiaries: function () {
			if (this.newOrder.type !== "PAPER") {
				return this.customerBeneficiaries.length;
			} else {
				let totalValue = parseInt(0);
				for (let index in this.customerBeneficiaries) {
					totalValue += parseInt(this.customerBeneficiaries[index].booklets);
				}
				return totalValue;
			}
		},
		orderHasNewBeneficiary: function () {
			for (let index in this.customerBeneficiaries) {
				if (this.customerBeneficiaries[index].newBeneficiary === true) {
					return true;
				}
			}
			return false;
		},
		beneficiariesForSubmit: function () {
			let returnBeneficiaries = [];
			if (this.newOrder.type === "PAPER") {
				for (let index in this.customerBeneficiaries) {
					returnBeneficiaries.push({
						booklets: this.customerBeneficiaries[index].booklets,
						first_name: this.customerBeneficiaries[index].first_name,
						// amount: parseFloat(
						// 	this.getTotalAmountForPaper(this.customerBeneficiaries[index])
						// 		.toString()
						// 		.replace(/ /g, "")
						// ),
						vouchers: parseFloat(
							this.customerBeneficiaries[index].vouchers
								.toString()
								.replace(/ /g, "")
						),
						nominal_value: parseFloat(
							this.customerBeneficiaries[index].nominal_value
								.toString()
								.replace(/ /g, "")
						),
						vouchers1: parseFloat(
							this.customerBeneficiaries[index].vouchers1
								.toString()
								.replace(/ /g, "")
						),
						nominal_value1: parseFloat(
							this.customerBeneficiaries[index].nominal_value1
								.toString()
								.replace(/ /g, "")
						),
						vouchers2: parseFloat(
							this.customerBeneficiaries[index].vouchers2
								.toString()
								.replace(/ /g, "")
						),
						nominal_value2: parseFloat(
							this.customerBeneficiaries[index].nominal_value2
								.toString()
								.replace(/ /g, "")
						),
						address: this.customerBeneficiaries[index].address,
					});
				}
			} else {
				for (let index in this.customerBeneficiaries) {
					if (
						(this.customerBeneficiaries[index].nominal_value !== 0 &&
							this.customerBeneficiaries[index].nominal_value !== "0.00") ||
						this.customerBeneficiaries[index].newBeneficiary
					) {
						let ben = {
							from_source_id: this.customerBeneficiaries[index].from_source_id
								? this.customerBeneficiaries[index].from_source_id
								: 0,
							first_name: this.customerBeneficiaries[index].first_name,
							last_name: this.customerBeneficiaries[index].last_name,
							vouchers: this.customerBeneficiaries[index].newBeneficiary
								? 0
								: 1,
							cards: this.customerBeneficiaries[index].newBeneficiary
								? this.customerBeneficiaries[index].cards
								: 0,
							nominal_value: parseFloat(
								this.customerBeneficiaries[index].nominal_value
									.toString()
									.replace(/ /g, "")
							),
							total_nominal_value: parseFloat(
								this.customerBeneficiaries[index].nominal_value
									.toString()
									.replace(/ /g, "")
							),
						};
						if (!this.newOrder.virtual) {
							ben.address = this.customerBeneficiaries[index].address
								? this.customerBeneficiaries[index].address
								: 0;
							ben.beneficiary_address =
								this.customerBeneficiaries[index].beneficiary_address;
						} else {
							ben.phone = this.customerBeneficiaries[index].phone;
							ben.email = this.customerBeneficiaries[index].email;
						}
						returnBeneficiaries.push(ben);
					}
				}
			}
			return returnBeneficiaries;
		},
		productLogo: function () {
			if (this.newOrder.product) {
				for (let index in this.customer.products) {
					if (
						this.customer.products[index].paper === this.newOrder.product.id
					) {
						return this.customer.products[index].logo;
					}
				}
			}
			return null;
		},
		isOrderProductReward() {
			return this.newOrder.product.brand === "rewards";
		},
		isOrderProductHoliday() {
			return this.newOrder.product.brand === "vacanta";
		},
	},
	watch: {
		defaultVouchers: function () {
			this.setDefaultValuesForNEWCR();
		},
		defaultTicketValue: function () {
			this.setDefaultValuesForNEWCR();
		},
		b_nominal_value: function () {
			if (this.isOrderProductReward) {
				this.b_address1 = this.b_nominal_value;
			}
		},
		bt_amount: function (newValue, oldValue) {
			if (newValue > 175) {
				this.bt_amount = oldValue;
				// this.bt_numberOfTickets1 = 0;
				// this.bt_numberOfTickets2 = 0;
				// this.bt_numberOfTickets3 = 0;
				this.error = { code: "VALUE_MAX_PAPER" };
				this.showModalPopup("modal_popup_info", true);

				return;
			} else {
				// if ()
				// 5, 2, 1
				if (Number(this.bt_amount) !== 0) {
					this.bt_amount1 = 5;
					this.bt_amount2 = 2;
					this.bt_amount3 = 1;

					let percentage5 = Math.max(
						this.bt_amount / this.bt_amount1 / 35,
						0.9
					);

					if (this.bt_amount > 150) {
						this.bt_numberOfTickets1 = Math.floor(35 * percentage5);
					} else {
						this.bt_numberOfTickets1 = Math.floor(
							(this.bt_amount * percentage5) / 5
						);
					}
					let temp = this.bt_amount;
					// this.bt_numberOfTickets1 = Math.floor(this.bt_amount *  percentage5 / 5 );
					temp -= this.bt_numberOfTickets1 * 5;
					let percentage2 = 0.85;

					this.bt_numberOfTickets2 = Math.floor(
						(temp * percentage2) / this.bt_amount2
					);
					this.bt_numberOfTickets3 =
						temp - this.bt_numberOfTickets2 * this.bt_amount2;
				}
			}
		},
		bt_amount1: function () {
			if (Number(this.bt_amount1) !== 5.0) {
				this.bt_amount = 0;
			}
		},
		bt_amount2: function () {
			if (Number(this.bt_amount2) !== 2) {
				this.bt_amount = 0;
			}
		},
		bt_amount3: function () {
			if (Number(this.bt_amount3) !== 1) {
				this.bt_amount = 0;
			}
		},
		b_email: function () {
			if (this.b_email.length > 0 && this.b_email !== null) {
				$(".phone").prop("disabled", true);
			} else {
				$(".phone").prop("disabled", false);
			}
		},
		b_mobileNumber: function () {
			if (this.b_mobileNumber.length > 2) {
				$(".email").prop("disabled", true);
			} else {
				$(".email").prop("disabled", false);
			}
		},
		// bt_numberOfTickets1: function(){
		// 	this.bt_amount = 0;
		// },
		// bt_numberOfTickets2: function(){
		// 	this.bt_amount = 0;
		// },
		// bt_numberOfTickets3: function(){
		// 	this.bt_amount = 0;
		// },
	},
	mounted() {
		this.token = Cookies.get("token");
		this.b_nominal_value = this.defaultTicketValue;
		// let now = moment(new Date(), "YYYY-MM-DDThh:mm:ss");
		// if (now >= this.millesime_time[0] && now <= this.millesime_time[1]) {
		//   this.order_available = false;
		// }
	},
	created() {
		if (this.$route.params.order) {
			this.getDeliveryAddreses();
			this.selectOrder(this.$route.params.order);
		}
	}
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
@media (max-width: 1003px) {
	.table-mobile {
		display: block;
	}
}

@media (max-width: 345px) {
	.invoices-filter .reportrange-text {
		height: auto;
	}
}

.orders-popup {
	position: absolute !important;
	left: 0;
	right: 0;
	top: 10px;
	margin-left: auto;
	margin-right: auto;
}

.error-scroll {
	max-height: 500px;
	overflow-y: auto;
}

.selected {
	color: darkblue;
	font-weight: bold;
}
</style>
